// import React, { useState, useEffect, useMemo, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";

// // --- CHART.JS IMPORTS ---
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   Filler,
// } from "chart.js";
// import { Bar } from "react-chartjs-2";

// // --- ICON IMPORTS ---
// import {
//   BsBugFill,
//   BsFileEarmarkPlusFill,
//   BsClockHistory,
//   BsBuilding,
//   BsTrophyFill,
//   BsListCheck,
//   BsArrowRepeat,
//   BsPauseCircleFill,
//   BsPersonCheckFill,
//   BsStopwatch,
//   BsCircleFill,
//   BsPersonBadge,
// } from "react-icons/bs";

// import DateRangeFilter from "../components/DateRangeFilter";
// import "../assets/css/dashboard.css";

// import {
//   dashboardClientStatusListsApis,
//   dashboardQueryTypeListsApis,
//   dashboardSummaryListsApis,
//   dashboarUserStatusListsApis,
// } from "../redux/dashboard/dashboardActions";
// import {
//   selectClientStatusData,
//   selectQueryTypeData,
//   selectSummaryData,
//   selectUserStatusData,
// } from "../redux/dashboard/dashboardSelectors";
// import { fetchQueryTypeApi } from "../redux/dashboard/dashboardApi";

// // --- REGISTER CHARTJS COMPONENTS ---
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   Filler,
// );

// // --- MOCK DATA FOR LEAVE (5 Users) ---
// const MOCK_LEAVE_DATA = [
//   { name: "Vikram", id: 101 },
//   { name: "Priya", id: 102 },
//   { name: "Rajesh", id: 103 },
//   { name: "Divya", id: 104 },
//   { name: "Karthik", id: 105 },
// ];

// // --- ANIMATED COUNTER ---
// const AnimatedCounter = ({ value, duration = 1500 }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const end = parseInt(value, 10) || 0;
//     if (end === 0) {
//       setCount(0);
//       return;
//     }
//     if (start === end) return;
//     let timer = setInterval(() => {
//       start += Math.ceil(end / (duration / 20));
//       if (start >= end) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(start);
//       }
//     }, 20);
//     return () => clearInterval(timer);
//   }, [value, duration]);

//   return <span>{count}</span>;
// };

// // --- PROFILE CARD INNER ---
// const ProfileCardInner = ({
//   bestPerformer,
//   colors,
//   calculateEfficiency,
//   getInitials,
// }) => {
//   if (!bestPerformer)
//     return (
//       <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
//         <div className="spinner-border text-primary mb-2" role="status"></div>
//         <span style={{ fontSize: "0.8rem" }}>Calculating Top Performer...</span>
//       </div>
//     );

//   return (
//     <>
//       <div className="avatar-ring-container">
//         <div
//           className="circular-progress"
//           style={{
//             background: `conic-gradient(${colors.primaryBlue} ${
//               calculateEfficiency(bestPerformer) * 3.6
//             }deg, #e5e7eb 0deg)`,
//           }}
//         >
//           <div className="profile-avatar">
//             {getInitials(bestPerformer.UserName)}
//           </div>
//         </div>
//       </div>
//       <div className="profile-info">
//         <h3 className="profile-name">{bestPerformer.UserName}</h3>
//         <p className="profile-role">Yesterday's Star</p>
//       </div>
//       <div className="profile-stats-row">
//         <div className="p-stat-item">
//           <span className="p-stat-val">
//             <AnimatedCounter value={bestPerformer.Total_Nos || 0} />
//           </span>
//           <span className="p-stat-lbl">Tasks</span>
//         </div>
//         <div className="p-stat-item">
//           <span className="p-stat-val" style={{ color: colors.successGreen }}>
//             <AnimatedCounter value={calculateEfficiency(bestPerformer)} />%
//           </span>
//           <span className="p-stat-lbl">Score</span>
//         </div>
//         <div className="p-stat-item">
//           <span className="p-stat-val" style={{ color: colors.red }}>
//             <AnimatedCounter value={bestPerformer.Bug_Nos || 0} />
//           </span>
//           <span className="p-stat-lbl">Bugs</span>
//         </div>
//       </div>
//     </>
//   );
// };

// // --- MAIN DASHBOARD COMPONENT ---
// const Dashboard = () => {
//   const dispatch = useDispatch();

//   // SELECTORS
//   const clientStatusData = useSelector(selectClientStatusData);
//   const queryTypeList = useSelector(selectQueryTypeData);
//   const summaryLists = useSelector(selectSummaryData);
//   const userStatusLists = useSelector(selectUserStatusData);

//   // STATE
//   const [dateRange, setDateRange] = useState({
//     start: new Date().toISOString().split("T")[0],
//     end: new Date().toISOString().split("T")[0],
//   });
//   const [yesterdayPerformer, setYesterdayPerformer] = useState(null);
//   const [liveTeamStatus, setLiveTeamStatus] = useState([]);
//   const [activeTab, setActiveTab] = useState("idle");
//   const [animationStage, setAnimationStage] = useState(() => {
//     return localStorage.getItem("dashboard_animation_played")
//       ? "finished"
//       : "celebrating";
//   });
//   const [flyStyles, setFlyStyles] = useState({});

//   // REFS
//   const lastRequestRef = useRef(null);
//   const realCardRef = useRef(null);
//   const celebrationCardRef = useRef(null);
//   const hasFetchedYesterday = useRef(false);

//   // COLORS
//   const colors = {
//     primaryBlue: "#3b82f6",
//     red: "rgb(211, 47, 47)",
//     orange: "rgb(245, 124, 0)",
//     successGreen: "#10B981",
//     teal: "#20c997",
//   };

//   // --- HELPER FUNCTIONS ---
//   const getInitials = (name) => {
//     if (!name) return "U";
//     const parts = name.split(" ");
//     return parts.length > 1
//       ? (parts[0][0] + parts[1][0]).toUpperCase()
//       : name.slice(0, 2).toUpperCase();
//   };

//   const calculateEfficiency = (user) => {
//     if (!user || !user.Total_Nos || user.Total_Nos === 0) return 0;
//     const penalty = user.Bug_Nos * 15 + user.Rework_Nos * 10;
//     let eff = 100 - (penalty / (user.Total_Nos || 1)) * 5;
//     return Math.max(Math.min(Math.round(eff), 100), 0);
//   };

//   const handleDateChange = (start, end) => {
//     const formatDate = (d) =>
//       d ? new Date(d).toISOString().split("T")[0] : null;
//     setDateRange({ start: formatDate(start), end: formatDate(end) });
//   };

//   // --- EFFECTS ---
//   useEffect(() => {
//     if (animationStage === "celebrating") {
//       localStorage.setItem("dashboard_animation_played", "true");
//     }
//   }, [animationStage]);

//   useEffect(() => {
//     if (dateRange.start && dateRange.end) {
//       const payload = { fromDate: dateRange.start, toDate: dateRange.end };
//       const requestKey = JSON.stringify(payload);
//       if (lastRequestRef.current === requestKey) return;
//       lastRequestRef.current = requestKey;

//       dispatch(dashboardClientStatusListsApis(payload));
//       dispatch(dashboardQueryTypeListsApis(payload));
//       dispatch(dashboardSummaryListsApis(payload));
//       dispatch(dashboarUserStatusListsApis(payload));
//     }
//   }, [dispatch, dateRange.start, dateRange.end]);

//   useEffect(() => {
//     if (
//       userStatusLists &&
//       Array.isArray(userStatusLists) &&
//       userStatusLists.length > 0
//     ) {
//       setLiveTeamStatus(userStatusLists);
//     }
//   }, [userStatusLists]);

//   useEffect(() => {
//     if (hasFetchedYesterday.current) return;
//     hasFetchedYesterday.current = true;
//     const fetchYesterdayData = async () => {
//       try {
//         const today = new Date();
//         const yesterday = new Date(today);
//         yesterday.setDate(yesterday.getDate() - 1);
//         const yesterdayStr = yesterday.toISOString().split("T")[0];
//         const params = { fromDate: yesterdayStr, toDate: yesterdayStr };
//         const response = await fetchQueryTypeApi(params);
//         const dataList = response?.data?.data || response?.data;
//         console.log(dataList, "dataList 322");

//         if (dataList && Array.isArray(dataList) && dataList.length > 0) {
//           const best = [...dataList]
//             .filter((user) => user.UserCode !== 12) // 1. Exclude Arjunan first
//             .sort((a, b) => {
//               // 2. Sort the remaining users
//               const effA = calculateEfficiency(a);
//               const effB = calculateEfficiency(b);
//               const totalA = a.Total_Nos || 0;
//               const totalB = b.Total_Nos || 0;

//               // Sort primarily by highest total tasks
//               if (totalB !== totalA) return totalB - totalA;

//               // If total tasks are a tie, sort by efficiency score
//               return effB - effA;
//             })[0];

//           setYesterdayPerformer(best);
//         } else {
//           setYesterdayPerformer(null);
//         }
//       } catch (error) {
//         console.error("Error fetching yesterday's data:", error);
//       }
//     };
//     fetchYesterdayData();
//   }, []);

//   // --- SMOOTH ANIMATION LOGIC ---
//   useEffect(() => {
//     if (animationStage === "celebrating" && yesterdayPerformer) {
//       const timer = setTimeout(() => {
//         if (!realCardRef.current || !celebrationCardRef.current) return;

//         const destRect = realCardRef.current.getBoundingClientRect();
//         const srcRect = celebrationCardRef.current.getBoundingClientRect();

//         const deltaX = destRect.left - srcRect.left;
//         const deltaY = destRect.top - srcRect.top;

//         setFlyStyles({
//           transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(1)`,
//           width: `${destRect.width}px`,
//           height: `${destRect.height}px`,
//           margin: 0,
//         });

//         setAnimationStage("flying");

//         setTimeout(() => setAnimationStage("finished"), 800);
//       }, 2500);

//       return () => clearTimeout(timer);
//     }
//   }, [yesterdayPerformer, animationStage]);

//   // --- KPI STATS ---
//   const kpiStats = useMemo(() => {
//     const safeSummary = Array.isArray(summaryLists) ? summaryLists : [];
//     const safeQueryType = Array.isArray(queryTypeList) ? queryTypeList : [];
//     const grandTotalRow =
//       safeSummary.find((item) => item.CompanyName === "GRAND TOTAL") || {};
//     const totalBugs = safeQueryType.reduce(
//       (acc, user) => acc + (user.Bug_Nos || 0),
//       0,
//     );
//     const totalReworks = safeQueryType.reduce(
//       (acc, user) => acc + (user.Rework_Nos || 0),
//       0,
//     );
//     const totalNewTasks = safeQueryType.reduce(
//       (acc, user) => acc + (user.NewTask_Nos || 0),
//       0,
//     );

//     return {
//       totalQueries: grandTotalRow.Total_Nos || 0,
//       completed: grandTotalRow.Complete_Nos || 0,
//       inProgress: grandTotalRow.InProgress_Nos || 0,
//       onHold: grandTotalRow.OnHold_Nos || 0,
//       bugs: totalBugs,
//       reworks: totalReworks,
//       newTasks: totalNewTasks,
//       avgTime: "4h 30m",
//       age02: grandTotalRow.Age_0_2 || 0,
//       age35: grandTotalRow.Age_3_5 || 0,
//       age6Plus: grandTotalRow.Age_6_Plus || 0,
//     };
//   }, [summaryLists, queryTypeList]);

//   const companyList = useMemo(() => {
//     if (!Array.isArray(summaryLists)) return [];
//     return summaryLists.filter(
//       (item) =>
//         item.CompanyName &&
//         item.CompanyName !== "GRAND TOTAL" &&
//         item.CompanyName !== "",
//     );
//   }, [summaryLists]);

//   // --- FIXED CHART DATA (BOLD PILLS) ---
//   const clientActivityChartData = useMemo(() => {
//     if (!clientStatusData || !Array.isArray(clientStatusData))
//       return { labels: [], datasets: [] };

//     const topClients = [...clientStatusData]
//       .filter((c) => c.Total_Nos > 0)
//       .sort((a, b) => b.Total_Nos - a.Total_Nos)
//       .slice(0, 5);

//     // Convert 0 to null to hide empty pills
//     const cleanData = (val) => (val === 0 ? null : val);

//     // Common Configuration for Bold Pills
//     const pillSettings = {
//       barThickness: 40, // Bold width
//       maxBarThickness: 50,
//       minBarLength: 15, // Ensure even small tasks are visible as dots
//       borderRadius: 20, // Fully rounded corners
//       borderSkipped: false, // CRITICAL: Rounds bottom corners too
//       borderWidth: {
//         // Creates the gap
//         top: 4,
//         bottom: 4,
//         left: 0,
//         right: 0,
//       },
//       borderColor: "#ffffff", // Gap matches background
//       stack: "Stack 0",
//     };

//     return {
//       labels: topClients.map((c) =>
//         c.ClientName && c.ClientName.length > 12
//           ? c.ClientName.substring(0, 12) + "..."
//           : c.ClientName || "",
//       ),
//       datasets: [
//         {
//           ...pillSettings,
//           label: "New Tasks",
//           data: topClients.map((c) => cleanData(c.NewTask_Nos)),
//           backgroundColor: "#3b82f6",
//         },
//         {
//           ...pillSettings,
//           label: "Bugs",
//           data: topClients.map((c) => cleanData(c.Bug_Nos)),
//           backgroundColor: "#8b5cf6",
//         },
//         {
//           ...pillSettings,
//           label: "Reworks",
//           data: topClients.map((c) => cleanData(c.Rework_Nos)),
//           backgroundColor: "#4f46e5",
//         },
//       ],
//     };
//   }, [clientStatusData]);

//   // --- FIXED CHART OPTIONS (CLEAN GRID) ---
//   const stackedBarOptions = {
//     responsive: true,
//     maintainAspectRatio: false, // Prevents squashing
//     layout: { padding: { top: 20, bottom: 10, left: 10, right: 10 } },
//     plugins: {
//       legend: {
//         position: "top",
//         align: "end",
//         labels: {
//           usePointStyle: true,
//           pointStyle: "circle",
//           boxWidth: 8,
//           padding: 20,
//           font: { size: 12, family: "'Inter', sans-serif" },
//         },
//       },
//       tooltip: {
//         backgroundColor: "#1f2937",
//         titleColor: "#fff",
//         bodyColor: "#fff",
//         padding: 12,
//         cornerRadius: 8,
//         displayColors: true,
//         usePointStyle: true,
//       },
//     },
//     scales: {
//       x: {
//         stacked: true,
//         grid: { display: false, drawBorder: false }, // No grid lines
//         ticks: { color: "#9ca3af", font: { size: 11 } },
//         border: { display: false },
//       },
//       y: {
//         stacked: true,
//         beginAtZero: true,
//         grid: {
//           display: true,
//           color: "#f3f4f6", // Very subtle horizontal lines
//           drawBorder: false,
//           borderDash: [5, 5],
//         },
//         ticks: { display: false }, // Hide Y-axis numbers for cleaner look
//         border: { display: false },
//       },
//     },
//     elements: { bar: { inflateAmount: "auto" } },
//   };

//   const lineOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: { legend: { display: false } },
//     scales: {
//       x: { stacked: true, grid: { display: false } },
//       y: { stacked: true, grid: { borderDash: [4, 4], color: "#f0f0f0" } },
//     },
//   };

//   const workloadChartData = {
//     labels: Array.isArray(queryTypeList)
//       ? queryTypeList.map((p) => p.UserName)
//       : [],
//     datasets: [
//       {
//         label: "New Tasks",
//         data: Array.isArray(queryTypeList)
//           ? queryTypeList.map((p) => p.NewTask_Nos)
//           : [],
//         backgroundColor: colors.primaryBlue,
//         borderRadius: 4,
//         barThickness: 15,
//       },
//       {
//         label: "Bugs",
//         data: Array.isArray(queryTypeList)
//           ? queryTypeList.map((p) => p.Bug_Nos)
//           : [],
//         backgroundColor: colors.red,
//         borderRadius: 4,
//         barThickness: 15,
//       },
//       {
//         label: "Reworks",
//         data: Array.isArray(queryTypeList)
//           ? queryTypeList.map((p) => p.Rework_Nos)
//           : [],
//         backgroundColor: colors.orange,
//         borderRadius: 4,
//         barThickness: 15,
//       },
//     ],
//   };

//   const StatusBadge = ({ count, color, bg }) => (
//     <span
//       className="badge-pill"
//       style={{
//         color: count > 0 ? color : "#9ca3af",
//         backgroundColor: count > 0 ? bg : "#f3f4f6",
//         minWidth: "35px",
//         textAlign: "center",
//       }}
//     >
//       {count}
//     </span>
//   );

//   const { workingUsers, idleUsers } = useMemo(() => {
//     const working = liveTeamStatus.filter((u) => u.ClientName !== null);
//     const idle = liveTeamStatus.filter(
//       (u) => u.ClientName === null && u.UserName !== "SUPER_ADMIN",
//     );
//     return { workingUsers: working, idleUsers: idle };
//   }, [liveTeamStatus]);

//   return (
//     <div className="modern-dashboard">
//       {/* CELEBRATION OVERLAY */}
//       {animationStage !== "finished" && yesterdayPerformer && (
//         <div
//           className={`celebration-overlay ${animationStage === "flying" ? "overlay-hidden" : ""}`}
//         >
//           <div className="celebration-content">
//             <h1
//               className={`congrats-text ${animationStage === "flying" ? "fade-out" : ""}`}
//             >
//               🎉 Yesterday's Top Performer 🎉
//             </h1>
//             <div
//               ref={celebrationCardRef}
//               className="celebration-card-wrapper"
//               style={animationStage === "flying" ? flyStyles : {}}
//             >
//               <div
//                 className="profile-card"
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   minHeight: "380px",
//                   boxShadow: "none",
//                   border: "none",
//                 }}
//               >
//                 <div className="profile-header">
//                   <span>Productivity Star</span>
//                   <BsTrophyFill className="text-warning" size={24} />
//                 </div>
//                 <ProfileCardInner
//                   bestPerformer={yesterdayPerformer}
//                   colors={colors}
//                   calculateEfficiency={calculateEfficiency}
//                   getInitials={getInitials}
//                   isAnimated={false}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* HEADER */}
//       <div className="dash-header">
//         <div>
//           <h2 className="dash-title">Dashboard Overview</h2>
//           <p className="dash-subtitle">
//             Real-time insights into your team's performance.
//           </p>
//         </div>
//         <div className="dash-actions">
//           <DateRangeFilter
//             startDate={dateRange.start}
//             endDate={dateRange.end}
//             onChange={handleDateChange}
//           />
//         </div>
//       </div>

//       {/* KPI GRID */}
//       <div className="kpi-grid">
//         <div
//           ref={realCardRef}
//           className={`profile-card real-card ${animationStage === "finished" ? "visible" : ""}`}
//         >
//           <div className="profile-header">
//             <span>Productivity Star</span>
//             <BsTrophyFill className="text-warning" />
//           </div>
//           <ProfileCardInner
//             bestPerformer={yesterdayPerformer}
//             colors={colors}
//             calculateEfficiency={calculateEfficiency}
//             getInitials={getInitials}
//           />
//         </div>
//         <div className="gradient-card grad-orange delay-1">
//           <div className="g-card-header">
//             <span className="g-card-title">Total Queries</span>
//             <div className="g-icon-box">
//               <BsFileEarmarkPlusFill />
//             </div>
//           </div>
//           <h2 className="g-card-value">
//             <AnimatedCounter value={kpiStats.totalQueries} />
//           </h2>
//           <div className="g-card-footer">{kpiStats.completed} Completed</div>
//         </div>
//         <div className="gradient-card grad-blue delay-2">
//           <div className="g-card-header">
//             <span className="g-card-title">Total Bugs</span>
//             <div className="g-icon-box">
//               <BsBugFill />
//             </div>
//           </div>
//           <h2 className="g-card-value">
//             <AnimatedCounter value={kpiStats.bugs} />
//           </h2>
//           <div className="g-card-footer">{kpiStats.reworks} Reworks</div>
//         </div>
//         <div className="gradient-card grad-green delay-3">
//           <div className="g-card-header">
//             <span className="g-card-title">Avg. Time</span>
//             <div className="g-icon-box">
//               <BsClockHistory />
//             </div>
//           </div>
//           <h2 className="g-card-value">{kpiStats.avgTime}</h2>
//           <div className="g-card-footer">On Track</div>
//         </div>
//         <div className="gradient-card grad-teal delay-4">
//           <div className="g-card-header">
//             <span className="g-card-title">Total New Tasks</span>
//             <div className="g-icon-box">
//               <BsListCheck />
//             </div>
//           </div>
//           <h2 className="g-card-value">
//             <AnimatedCounter value={kpiStats.newTasks} />
//           </h2>
//           <div className="g-card-footer">Assigned</div>
//         </div>
//         <div className="gradient-card grad-red delay-5">
//           <div className="g-card-header">
//             <span className="g-card-title">Total Reworks</span>
//             <div className="g-icon-box">
//               <BsArrowRepeat />
//             </div>
//           </div>
//           <h2 className="g-card-value">
//             <AnimatedCounter value={kpiStats.reworks} />
//           </h2>
//           <div className="g-card-footer">Needs Attention</div>
//         </div>
//         <div className="gradient-card grad-yellow delay-6">
//           <div className="g-card-header">
//             <span className="g-card-title">On Hold</span>
//             <div className="g-icon-box">
//               <BsPauseCircleFill />
//             </div>
//           </div>
//           <h2 className="g-card-value">
//             <AnimatedCounter value={kpiStats.onHold} />
//           </h2>
//           <div className="g-card-footer">Pending Review</div>
//         </div>
//       </div>

//       {/* --- MIDDLE SECTION --- */}
//       <div
//         className="split-grid d-flex gap-3 align-items-stretch"
//         style={{ flexWrap: "wrap" }}
//       >
//         <div
//           className="content-card d-flex flex-column"
//           style={{ flex: "2 1 500px" }}
//         >
//           <div className="card-header-custom">
//             <h5>Top Client Activity</h5>
//           </div>
//           <div
//             className="flex-grow-1"
//             style={{ position: "relative", minHeight: "350px" }}
//           >
//             <Bar data={clientActivityChartData} options={stackedBarOptions} />
//           </div>
//         </div>

//         <div className="content-card" style={{ flex: "1 1 300px" }}>
//           <div className="card-header-custom">
//             <h5 className="d-flex align-items-center gap-2">
//               Live Team Status
//             </h5>
//             <BsPersonCheckFill className="text-primary opacity-50" size={20} />
//           </div>
//           <div className="d-flex gap-4 border-bottom px-3 pt-2 mb-2">
//             <div
//               style={{ cursor: "pointer" }}
//               className={`cursor-pointer pb-2 small ${activeTab === "idle" ? "border-bottom border-3 border-primary text-primary fw-bold" : "text-muted"}`}
//               onClick={() => setActiveTab("idle")}
//             >
//               Idle / Available ({idleUsers.length})
//             </div>
//             <div
//               style={{ cursor: "pointer" }}
//               className={`cursor-pointer pb-2 small ${activeTab === "working" ? "border-bottom border-3 border-primary text-primary fw-bold" : "text-muted"}`}
//               onClick={() => setActiveTab("working")}
//             >
//               Working Now ({workingUsers.length})
//             </div>
//           </div>
//           <div
//             className="attendance-container d-flex flex-column flex-grow-1"
//             style={{ overflowY: "auto", maxHeight: "350px" }}
//           >
//             {activeTab === "working" ? (
//               <div className="user-status-list">
//                 {workingUsers.length > 0 ? (
//                   workingUsers.map((user, idx) => (
//                     <div
//                       key={idx}
//                       className="user-status-item p-2 mb-2 border rounded bg-light d-flex flex-column"
//                     >
//                       <div className="d-flex align-items-center justify-content-between w-100">
//                         <div
//                           className="d-flex align-items-center gap-2"
//                           style={{ marginRight: "auto" }}
//                         >
//                           <div
//                             className="user-avatar-sm flex-shrink-0"
//                             style={{
//                               width: "28px",
//                               height: "28px",
//                               fontSize: "10px",
//                             }}
//                           >
//                             {getInitials(user.UserName)}
//                           </div>
//                           <span
//                             className="fw-bold text-dark"
//                             style={{ whiteSpace: "nowrap" }}
//                           >
//                             {user.UserName}
//                           </span>
//                         </div>
//                         <div
//                           className="text-primary small mx-2 d-none d-sm-block text-truncate"
//                           style={{ maxWidth: "120px" }}
//                           title={user.ClientName}
//                         >
//                           <BsBuilding className="me-1" />
//                           {user.ClientName}
//                         </div>
//                         <div className="flex-shrink-0">
//                           <span
//                             className="badge bg-white text-success border border-success border-opacity-25 rounded-pill px-2"
//                             style={{ fontWeight: "600" }}
//                           >
//                             <BsStopwatch className="me-1" />
//                             {user.RunningTime
//                               ? user.RunningTime.replace("0 Days ", "")
//                               : "00:00"}
//                           </span>
//                         </div>
//                       </div>
//                       <div className="d-block d-sm-none mt-1">
//                         <span className="text-primary small">
//                           <BsBuilding className="me-1" />
//                           {user.ClientName}
//                         </span>
//                       </div>
//                       {user.NatureofQuery && (
//                         <div
//                           className="mt-2 pt-1 border-top border-light text-muted small w-100"
//                           style={{
//                             display: "block",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             cursor: "pointer",
//                             fontSize: "0.75rem",
//                           }}
//                           title={user.NatureofQuery}
//                         >
//                           {user.NatureofQuery}
//                         </div>
//                       )}
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center p-4 text-muted">
//                     <small>No one is working currently.</small>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <div className="user-status-list p-2">
//                 {idleUsers.length > 0 ? (
//                   <div className="d-flex flex-column gap-2">
//                     {idleUsers.map((user, idx) => (
//                       <div
//                         key={idx}
//                         className="d-flex align-items-center justify-content-between p-2 border rounded bg-white"
//                       >
//                         <div className="d-flex align-items-center gap-2">
//                           <div
//                             className="user-avatar-sm"
//                             style={{
//                               width: "28px",
//                               height: "28px",
//                               fontSize: "10px",
//                               background: "#f3f4f6",
//                               color: "#6b7280",
//                             }}
//                           >
//                             {getInitials(user.UserName)}
//                           </div>
//                           <span className="fw-medium text-dark">
//                             {user.UserName}
//                           </span>
//                         </div>
//                         <span className="badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-10 rounded-pill px-2">
//                           <BsCircleFill
//                             size={6}
//                             className="me-1 text-secondary"
//                           />
//                           Idle
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="text-center p-4 text-muted fst-italic">
//                     <small>Everyone is currently working!</small>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* --- BOTTOM ROW --- */}
//       <div className="split-grid mt-3">
//         <div className="content-card" style={{ flex: 1.5 }}>
//           <div className="card-header-custom">
//             <h5>Team Performance</h5>
//           </div>
//           <div
//             className="table-scroll-section"
//             style={{ maxHeight: "640px", overflowY: "auto" }}
//           >
//             <table className="clean-table" style={{ width: "100%" }}>
//               <thead
//                 style={{
//                   position: "sticky",
//                   top: 0,
//                   backgroundColor: "#fff",
//                   zIndex: 10,
//                 }}
//               >
//                 <tr>
//                   <th>Employee</th>
//                   <th className="text-center">Bugs</th>
//                   <th className="text-center">Rework</th>
//                   <th className="text-center">Task</th>
//                   <th>Productivity</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {queryTypeList.map((person, index) => {
//                   const efficiency = calculateEfficiency(person);
//                   let progressColor =
//                     efficiency >= 90
//                       ? colors.successGreen
//                       : efficiency < 50
//                         ? colors.red
//                         : colors.primaryBlue;
//                   return (
//                     <tr key={index}>
//                       <td>
//                         <div className="d-flex align-items-center gap-2">
//                           <div className="avatar-circle">
//                             {getInitials(person.UserName)}
//                           </div>
//                           <div>
//                             <div className="fw-bold text-dark small">
//                               {person.UserName}
//                             </div>
//                             <div
//                               className="text-muted small"
//                               style={{ fontSize: "0.7rem" }}
//                             >
//                               Developer
//                             </div>
//                           </div>
//                         </div>
//                       </td>
//                       <td className="text-center">
//                         <StatusBadge
//                           count={person.Bug_Nos}
//                           color="#d32f2f"
//                           bg="#fce8e6"
//                         />
//                       </td>
//                       <td className="text-center">
//                         <StatusBadge
//                           count={person.Rework_Nos}
//                           color="#f57c00"
//                           bg="#fff3e0"
//                         />
//                       </td>
//                       <td className="text-center fw-bold text-dark">
//                         {person.NewTask_Nos}
//                       </td>
//                       <td>
//                         <div className="d-flex align-items-center gap-2">
//                           <div
//                             className="progress flex-grow-1"
//                             style={{
//                               height: "6px",
//                               minWidth: "60px",
//                               backgroundColor: "#e9ecef",
//                               borderRadius: "4px",
//                             }}
//                           >
//                             <div
//                               className="progress-bar"
//                               style={{
//                                 width: `${efficiency}%`,
//                                 backgroundColor: progressColor,
//                                 borderRadius: "4px",
//                               }}
//                             ></div>
//                           </div>
//                           <small className="text-muted">{efficiency}%</small>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="vertical-stack" style={{ flex: 1 }}>
//           <div className="content-card flex-grow-1">
//             <div className="card-header-custom">
//               <h5>Daily Workload</h5>
//             </div>
//             <div style={{ height: "180px", position: "relative" }}>
//               <Bar
//                 data={workloadChartData}
//                 options={{
//                   ...lineOptions,
//                   plugins: { legend: { display: false } },
//                 }}
//               />
//             </div>
//           </div>
//           <div
//             className="content-card d-flex flex-column"
//             style={{ height: "450px" }}
//           >
//             <div className="card-header-custom d-flex justify-content-between align-items-center">
//               <h5>Team Attendance</h5>
//               <BsPersonBadge className="text-primary opacity-50" size={24} />
//             </div>
//             <div
//               className="flex-grow-1 p-3 overflow-auto"
//               style={{ minHeight: 0 }}
//             >
//               <div className="text-success small fw-bold mb-2">
//                 ACTIVE TODAY ({workingUsers.length})
//               </div>
//               <div className="d-flex flex-column gap-2">
//                 {workingUsers.map((emp, i) => (
//                   <div
//                     key={i}
//                     className="d-flex align-items-center justify-content-between p-2 bg-light rounded-3"
//                   >
//                     <div className="d-flex align-items-center gap-2">
//                       <div
//                         className="rounded-circle d-flex align-items-center justify-content-center bg-secondary bg-opacity-10 text-secondary fw-bold"
//                         style={{
//                           width: "32px",
//                           height: "32px",
//                           fontSize: "12px",
//                         }}
//                       >
//                         {getInitials(emp.UserName)}
//                       </div>
//                       <span
//                         className="fw-bold text-dark"
//                         style={{ fontSize: "0.9rem" }}
//                       >
//                         {emp.UserName}
//                       </span>
//                     </div>
//                     <div className="badge bg-success bg-opacity-10 text-success rounded-pill px-3 py-1 d-flex align-items-center gap-1">
//                       <BsCircleFill size={6} /> Active
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//             <div
//               className="p-3 border-top bg-light-subtle"
//               style={{ flexShrink: 0 }}
//             >
//               <div className="text-danger small fw-bold mb-2">
//                 ON LEAVE ({MOCK_LEAVE_DATA.length})
//               </div>
//               <div style={{ maxHeight: "150px", overflowY: "auto" }}>
//                 <div className="d-flex flex-column gap-2">
//                   {MOCK_LEAVE_DATA.map((emp) => (
//                     <div
//                       key={emp.id}
//                       className="d-flex align-items-center justify-content-between p-2 bg-white border rounded-3"
//                     >
//                       <div className="d-flex align-items-center gap-2">
//                         <div
//                           className="rounded-circle d-flex align-items-center justify-content-center bg-danger bg-opacity-10 text-danger fw-bold"
//                           style={{
//                             width: "32px",
//                             height: "32px",
//                             fontSize: "12px",
//                           }}
//                         >
//                           {getInitials(emp.name)}
//                         </div>
//                         <span
//                           className="fw-bold text-dark"
//                           style={{ fontSize: "0.9rem" }}
//                         >
//                           {emp.name}
//                         </span>
//                       </div>
//                       <div className="badge bg-danger bg-opacity-10 text-danger rounded-pill px-3 py-1 d-flex align-items-center gap-1">
//                         <BsCircleFill size={6} /> Leave
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* COMPANY STATUS OVERVIEW */}
//       <div className="content-card mt-4">
//         <div className="card-header-custom">
//           <h5 className="d-flex align-items-center gap-2">
//             <BsBuilding className="text-primary opacity-50" /> Company Status
//             Overview
//           </h5>
//         </div>
//         <div
//           className="table-scroll-section"
//           style={{ maxHeight: "600px", overflowY: "auto" }}
//         >
//           <table className="clean-table" style={{ width: "100%" }}>
//             <thead
//               style={{
//                 position: "sticky",
//                 top: 0,
//                 backgroundColor: "#fff",
//                 zIndex: 10,
//               }}
//             >
//               <tr>
//                 <th style={{ width: "30%" }}>Company Name</th>
//                 <th className="text-center" style={{ width: "10%" }}>
//                   Complete
//                 </th>
//                 <th className="text-center" style={{ width: "10%" }}>
//                   Not Started
//                 </th>
//                 <th className="text-center" style={{ width: "10%" }}>
//                   In Progress
//                 </th>
//                 <th className="text-center" style={{ width: "10%" }}>
//                   On Hold
//                 </th>
//                 <th
//                   className="text-center border-start"
//                   style={{ width: "10%" }}
//                 >
//                   0-2 Days
//                 </th>
//                 <th className="text-center" style={{ width: "10%" }}>
//                   3-5 Days
//                 </th>
//                 <th className="text-center" style={{ width: "10%" }}>
//                   6+ Days
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {companyList.map((company, idx) => (
//                 <tr key={idx}>
//                   <td>
//                     <div className="fw-bold text-dark small">
//                       {company.CompanyName}
//                     </div>
//                   </td>
//                   <td className="text-center">
//                     <StatusBadge
//                       count={company.Complete_Nos}
//                       color="#0d5f41"
//                       bg="#d1fae5"
//                     />
//                   </td>
//                   <td className="text-center">
//                     <StatusBadge
//                       count={company.NotStarted_Nos}
//                       color="#4b5563"
//                       bg="#f3f4f6"
//                     />
//                   </td>
//                   <td className="text-center">
//                     <StatusBadge
//                       count={company.InProgress_Nos}
//                       color="#5b5fef"
//                       bg="#dbeafe"
//                     />
//                   </td>
//                   <td className="text-center">
//                     <StatusBadge
//                       count={company.OnHold_Nos}
//                       color="#b45309"
//                       bg="#fef3c7"
//                     />
//                   </td>
//                   <td className="text-center border-start fw-medium text-success">
//                     {company.Age_0_2 > 0 ? company.Age_0_2 : "-"}
//                   </td>
//                   <td className="text-center fw-medium text-warning">
//                     {company.Age_3_5 > 0 ? company.Age_3_5 : "-"}
//                   </td>
//                   <td className="text-center fw-bold text-danger">
//                     {company.Age_6_Plus > 0 ? company.Age_6_Plus : "-"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;


import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

// --- CHART.JS IMPORTS ---
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  plugins,
  ArcElement
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

// --- ICON IMPORTS ---
import {
  BsBugFill,
  BsFileEarmarkPlusFill,
  BsClockHistory,
  BsBuilding,
  BsTrophyFill,
  BsListCheck,
  BsArrowRepeat,
  BsPauseCircleFill,
  BsPersonCheckFill,
  BsStopwatch,
  BsCircleFill,
  BsPersonBadge,
} from "react-icons/bs";

import DateRangeFilter from "../components/DateRangeFilter";
import SkSelect from "../components/SkSelect";
import Loader from "../components/Loader"; // <-- CUSTOM LOADER IMPORTED
import "../assets/css/dashboard.css";
import { useWorkStatus } from "../context/WorkStatusContext";
import { useTabRefresh } from "../context/TabsContext";

// --- REDUX IMPORTS ---
import {
  dashboardClientStatusListsApis,
  dashboardQueryTypeListsApis,
  dashboardSummaryListsApis,
  summaryByProjectApis,
  dashboarUserStatusListsApis,
  dashboardQueriesCountAndProductivityStarApis,
  clockInEmployee,
  clockOutEmployee,
  getWorkingHours,
  getAttendanceDashboard,
  getTeamClockStatus,
  getBreakBreakdown
} from "../redux/dashboard/dashboardActions";
import {
  selectClientStatusData,
  selectQueryTypeData,
  selectSummaryData,
  selectUserStatusData,
  selectQueriesCountAndProductivityData,
  selectDashboardStatus, // <-- ADDED STATUS SELECTOR
  selectDashboardError,
  selectWorkingHoursData,
  selectClockInData,
  selectClockOutData,
  selectAttendanceDashboardData,
} from "../redux/dashboard/dashboardSelectors";
// import AttendanceCard from "../components/ClockCard";
import ClocksCard from "../components/ClockCard";
import TeamWorkloadPanel from "../components/TeamWorkloadPanel";
import ClockRosterPanel from "../components/ClockRosterPanel";
import ActiveTasksPanel from "../components/ActiveTasksPanel";
import DaySpellsStrip from "../components/DaySpellsStrip";
import PendingQueryTrack from "../components/PendingQueryTrack";
import "../assets/css/daySpells.css";
import "../assets/css/companyOverview.css";
import { formatRole } from "../utils/common";

/* YYYY-MM-DD in local terms. toISOString() would be wrong here: it converts to
   UTC first, so any time before 05:30 IST lands on the previous date and the
   roster would quietly answer for yesterday. */
const toApiDay = (d) => {
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return undefined;
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
// import { newDate } from "react-datepicker/dist/dist/date_utils.js";

// --- REGISTER CHARTJS COMPONENTS ---
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

// --- MOCK DATA FOR LEAVE (5 Users) ---
const MOCK_LEAVE_DATA = [
  { name: "Vikram", id: 101 },
  { name: "Priya", id: 102 },
  { name: "Rajesh", id: 103 },
  { name: "Divya", id: 104 },
  { name: "Karthik", id: 105 },
];


// --- ANIMATED COUNTER ---
const AnimatedCounter = ({ value, duration = 1500 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(value, 10) || 0;
    if (end === 0) {
      setCount(0);
      return;
    }
    if (start === end) return;
    let timer = setInterval(() => {
      start += Math.ceil(end / (duration / 20));
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 20);
    return () => clearInterval(timer);
  }, [value, duration]);

  return <span>{count}</span>;
};

// --- PROFILE CARD INNER ---
const ProfileCardInner = ({
  bestPerformer,
  colors,
  calculateEfficiency,
  getInitials,
}) => {
  if (!bestPerformer)
    return (
      <div className="d-flex flex-column align-items-center justify-content-center h-100 w-100">
        {/* Productivity Star placeholder */}
        <Loader inline variant="profile" />
      </div>
    );

  const name = bestPerformer.AssigneeName || bestPerformer.UserName;
  const tasks = bestPerformer.TotalTasks ?? bestPerformer.Total_Nos ?? 0;
  const bugs = bestPerformer.TotalBugs ?? bestPerformer.Bug_Nos ?? 0;
  const score = bestPerformer.ScorePercentage ?? calculateEfficiency(bestPerformer);

  return (

    <>

      <div className="avatar-ring-container">
        <div
          className="circular-progress"
          style={{
            background: `conic-gradient(${colors.primaryBlue} ${score * 3.6
              }deg, #e5e7eb 0deg)`,
          }}
        >
          <div className="profile-avatar">{getInitials(name)}</div>
        </div>
      </div>
      <div className="profile-info">
        <h3 className="profile-name">{name}</h3>
        <p className="profile-role">Yesterday's Star</p>
      </div>
      <div className="profile-stats-row">
        <div className="p-stat-item">
          <span className="p-stat-val">
            <AnimatedCounter value={tasks} />
          </span>
          <span className="p-stat-lbl">Tasks</span>
        </div>
        <div className="p-stat-item">
          <span className="p-stat-val" style={{ color: colors.successGreen }}>
            <AnimatedCounter value={score} />%
          </span>
          <span className="p-stat-lbl">Score</span>
        </div>
        <div className="p-stat-item">
          <span className="p-stat-val" style={{ color: colors.red }}>
            <AnimatedCounter value={bugs} />
          </span>
          <span className="p-stat-lbl">Bugs</span>
        </div>
      </div>
    </>
  );
};

// --- MAIN DASHBOARD COMPONENT ---
const Dashboard = () => {
//   console.log("Dashboard Props");
// console.log(workStatus);
// console.log(statusStartedAt);
  const dispatch = useDispatch();
  const {
    workStatus,
    statusStartedAt,
    onStatusChanged,
} = useWorkStatus();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  // SELECTORS
  const clientStatusData = useSelector(selectClientStatusData);
  const queryTypeList = useSelector(selectQueryTypeData);
  const summaryLists = useSelector(selectSummaryData);
  const userStatusLists = useSelector(selectUserStatusData);
  const queriesCountAndProductivityData = useSelector(selectQueriesCountAndProductivityData);
  const dashboardStatus = useSelector(selectDashboardStatus); // <-- READ LOADING STATUS
  const workingHoursData = useSelector(selectWorkingHoursData);
  const clockInData = useSelector(selectClockInData);
  const clockOutData = useSelector(selectClockOutData);
  const attendanceData = useSelector(selectAttendanceDashboardData);
  const teamClock = useSelector((state) => state.dashboard.teamClock);
  const teamClockLoading = useSelector((state) => state.dashboard.teamClockLoading);
  const breakBreakdown = useSelector((state) => state.dashboard.breakBreakdown);
  const lastLoginAt = useSelector((state) => state.dashboard.lastLoginAt);
  const [pageLoading, setPageLoading] = useState(
    localStorage.getItem("dashboard_loading") === "true"
  );
  const isDashboardLoading =
    dashboardStatus === "loading" && !clientStatusData.length;
  console.log("Redux workingHoursData:", workingHoursData);

  
  useEffect(() => {

    if (!workingHoursData) return;

    setTotalWorkedTime(
      workingHoursData.totalSeconds || 0
    );

    setRecentClockInTime(
      workingHoursData.recentClockInTime
    );

    setClockInDate(
      workingHoursData.clockInDate
    );

    // NOTE: isClockedIn is NOT derived here anymore — the working-hours signal is
    // unreliable (kept returning a clock-in time after clock-out), which caused the
    // button/state to disagree with the backend and spam "already clocked in".
    // The authoritative source is attendanceData.IsClockedIn (see effect below).

    setWorkedTime(
      formatTime(
        workingHoursData.totalSeconds || 0
      )
    );

  }, [workingHoursData]);

  useEffect(() => {
    if (dashboardStatus !== "loading" && pageLoading) {
      localStorage.removeItem("dashboard_loading");
      setPageLoading(false);
    }
  }, [dashboardStatus, pageLoading]);
  // STATE
  const [dateRange, setDateRange] = useState({
    start: new Date().toISOString().split("T")[0],
    end: new Date().toISOString().split("T")[0],
  });
  const [yesterdayPerformer, setYesterdayPerformer] = useState(null);
  const [liveTeamStatus, setLiveTeamStatus] = useState([]);
  const [activeTab, setActiveTab] = useState("idle");
  const [animationStage, setAnimationStage] = useState(() => {
    return localStorage.getItem("dashboard_animation_played")
      ? "finished"
      : "celebrating";
  });
  const [flyStyles, setFlyStyles] = useState({});
  const [isClockedIn, setIsClockedIn] = useState(false);
  
  // const [workStatus, setWorkStatus] = useState("ClockedOut");
  // const [statusStartedAt, setStatusStartedAt] = useState(null);
  // const [workedSeconds, setWorkedSeconds] = useState(0);
  const [firstClockIn, setFirstClockIn] = useState("--:--");
  const [clockIn, setClockIn] = useState("--:--");
  const [clockOut, setClockOut] = useState("--:--");
  // const [workingHours, setWorkingHours] = useState("00:00");
  const [breakHours, serBreakHours] = useState("00:00");
  const [todayDate, setTodayDate] = useState("00:00");
  const [workedTime, setWorkedTime] = useState("00h 00m");
  const [totalWorkedTime, setTotalWorkedTime] = useState(0);
  const [recentClockInTime, setRecentClockInTime] = useState(null);
  const [clockInDate, setClockInDate] = useState(null);

  // Live-running counters shown on the attendance card.
  // Working Hours ticks while clocked in; Break Hours ticks while clocked out.
  const [liveWorking, setLiveWorking] = useState("00:00:00");
  const [liveBreak, setLiveBreak] = useState("00:00:00");
  const [liveWorkingSeconds, setLiveWorkingSeconds] = useState(0);
  // const [frozenWorkingSeconds, setFrozenWorkingSeconds] = useState(0);
  const workingSecondsRef = useRef(0);
  const breakSecondsRef = useRef(0);
  const workingSegmentStartRef = useRef(null);
const breakSegmentStartRef = useRef(null);
const timerModeRef = useRef("idle");
// "idle" | "working" | "break" | "frozen"

const frozenWorkingSecondsRef = useRef(0);
const frozenBreakSecondsRef = useRef(0);

const clockOutInProgressRef = useRef(false);

//   const [workingBaseSeconds, setWorkingBaseSeconds] = useState(0);
// const [breakBaseSeconds, setBreakBaseSeconds] = useState(0);

  const formatTime = (totalSeconds) => {
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    return `${hrs}h ${mins.toString().padStart(2, "0")}m`;
  };
  console.log("PROP workStatus =", workStatus);
  console.log("PROP startedAt =", statusStartedAt);
  // useEffect(() => {

  //   if (!isClockedIn || !recentClockInTime || !clockInDate)
  //     return;

  //   const interval = setInterval(() => {

  //     let [time, modifier] =
  //       recentClockInTime.split(" ");

  //     let [h, m, s] =
  //       time.split(":").map(Number);

  //     if (modifier === "PM" && h !== 12)
  //       h += 12;

  //     if (modifier === "AM" && h === 12)
  //       h = 0;

  //     const [year, month, day] =
  //       clockInDate.split("-").map(Number);

  //     const clockInDateTime =
  //       new Date(
  //         year,
  //         month - 1,
  //         day,
  //         h,
  //         m,
  //         s
  //       );

  //     const runningSeconds =
  //       Math.floor(
  //         (Date.now() -
  //           clockInDateTime.getTime()) /
  //         1000
  //       );

  //     const finalSeconds =
  //       totalWorkedTime +
  //       runningSeconds;

  //     setWorkedTime(
  //       formatTime(finalSeconds)
  //     );

  //   }, 1000);

  //   return () => clearInterval(interval);

  // }, [
  //   isClockedIn,
  //   recentClockInTime,
  //   clockInDate,
  //   totalWorkedTime
  // ]);

  // --- LIVE ATTENDANCE COUNTERS (Working Hours / Break Hours) ---
  // Parse a "hh:mm AM/PM" clock string (today) into a millisecond timestamp.
  const parseClockToMs = (timeStr) => {
    if (!timeStr || typeof timeStr !== "string") return null;
    const parts = timeStr.trim().split(" ");
    if (parts.length < 2) return null;
    let [h, m] = parts[0].split(":").map(Number);
    const modifier = parts[1].toUpperCase();
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    if (modifier === "PM" && h !== 12) h += 12;
    if (modifier === "AM" && h === 12) h = 0;
    const d = new Date();
    d.setHours(h, m, 0, 0);
    return d.getTime();
  };

  // "HH:mm" -> seconds
  const hhmmToSeconds = (str) => {
    if (!str || typeof str !== "string") return 0;
    const [h = 0, m = 0, s = 0] = str.split(":").map(Number);

    // const [h, m] = str.split(":").map(Number);
    return ((h || 0) * 3600 + (m || 0) * 60 + (s || 0));
  };

  // seconds -> "HH:mm:ss" (shown with seconds so the running counter is visibly
  // ticking every second — HH:mm alone only changes once per minute and looks frozen).
  const secondsToHMS = (totalSeconds) => {
    const s = Math.max(0, Math.floor(totalSeconds));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(
      sec
    ).padStart(2, "0")}`;
  };

  const TIMER_STORAGE_KEY = "attendance_live_timer";

const getTodayKey = () => {
  const d = new Date();

  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
};

const saveTimerState = (data) => {
  try {
    localStorage.setItem(
      TIMER_STORAGE_KEY,
      JSON.stringify({
        date: getTodayKey(),
        ...data,
      })
    );
  } catch (error) {
    console.error("Unable to save timer state:", error);
  }
};

const getTimerState = () => {
  try {
    const raw = localStorage.getItem(TIMER_STORAGE_KEY);

    if (!raw) return null;

    const data = JSON.parse(raw);

    if (data.date !== getTodayKey()) {
      localStorage.removeItem(TIMER_STORAGE_KEY);
      return null;
    }

    return data;
  } catch (error) {
    console.error("Unable to read timer state:", error);
    return null;
  }
};

const clearTimerState = () => {
  localStorage.removeItem(TIMER_STORAGE_KEY);
};

const getCurrentWorkingSeconds = () => {
  const base = workingSecondsRef.current;

  if (!workingSegmentStartRef.current) {
    return Math.max(0, base);
  }

  const elapsed = Math.floor(
    (Date.now() - workingSegmentStartRef.current) / 1000
  );

  return Math.max(
    base,
    base + Math.max(0, elapsed)
  );
};


const getCurrentBreakSeconds = () => {
  const base = breakSecondsRef.current || 0;
  const start = breakSegmentStartRef.current;

  if (!start) {
    return Math.floor(base);
  }

  const elapsed = Math.floor(
    (Date.now() - start) / 1000
  );

  return Math.max(
    base,
    base + Math.max(0, elapsed)
  );
};

const freezeCurrentWorkingTimer = () => {
  const now = Date.now();

  let finalWorkingSeconds = workingSecondsRef.current;

  if (workingSegmentStartRef.current) {
    const elapsed = Math.floor(
      (now - workingSegmentStartRef.current) / 1000
    );

    finalWorkingSeconds += Math.max(0, elapsed);
  }

  finalWorkingSeconds = Math.max(
    0,
    Math.floor(finalWorkingSeconds)
  );

  // IMPORTANT: permanently freeze these refs
  frozenWorkingSecondsRef.current = finalWorkingSeconds;
  workingSecondsRef.current = finalWorkingSeconds;

  // Stop working timer
  workingSegmentStartRef.current = null;

  // Stop break timer also
  breakSegmentStartRef.current = null;

  // Change mode BEFORE API calls
  timerModeRef.current = "frozen";

  return finalWorkingSeconds;
};

  // useEffect(() => {
  //   // Base totals from the API already include only COMPLETED segments, so we
  //   // add the time elapsed in the currently-open segment on the fly.
  //   const baseWorkingSec = hhmmToSeconds(attendanceData?.TotalWorkingHours);
  //   const baseBreakSec = hhmmToSeconds(attendanceData?.BreakHours);
  //   const clockInMs = parseClockToMs(attendanceData?.RecentClockIn);
  //   const clockOutMs = parseClockToMs(attendanceData?.RecentClockOut);

  //   const tick = () => {
  //     // if (isClockedIn) 
  //     if (workStatus === "Active") {
  //       // Working Hours runs from the most recent clock-in; break is frozen.
  //       const extra = clockInMs
  //         ? Math.floor((Date.now() - clockInMs) / 1000)
  //         : 0;
  //       // setLiveWorking(secondsToHMS(baseWorkingSec + Math.max(0, extra)));
  //       setLiveWorking(secondsToHMS(baseWorkingSec + extra));
  //       setLiveBreak(secondsToHMS(baseBreakSec));
  //     }

  //     else if (
  //       workStatus === "Break" ||
  //       workStatus === "Lunch" ||
  //       workStatus === "Be Right Back"
  //     ) {
  //       // Break Hours runs from the most recent clock-out; working is frozen.
  //       const extra = clockOutMs
  //         ? Math.floor((Date.now() - clockOutMs) / 1000)
  //         : 0;
  //       //    setLiveBreak(secondsToHMS(baseBreakSec + Math.max(0, extra)));
  //       // setLiveWorking(secondsToHMS(baseWorkingSec));
  //       setLiveWorking(secondsToHMS(baseWorkingSec));
  //       setLiveBreak(secondsToHMS(baseBreakSec + extra));
  //     }
  //     else {
  //       setLiveWorking(secondsToHMS(baseWorkingSec));
  //       setLiveBreak(secondsToHMS(baseBreakSec));

  //     }
  //   };

  //   tick(); // update immediately, then every second
  //   const interval = setInterval(tick, 1000);
  //   return () => clearInterval(interval);
  // }, [attendanceData, workStatus]);

  console.log(attendanceData);
console.log("CurrentStatus:", attendanceData?.CurrentStatus);
console.log("statusStartedAt:", attendanceData?.statusStartedAt);
console.log("TotalWorkingHours:", attendanceData?.TotalWorkingHours);
console.log("BreakHours:", attendanceData?.BreakHours);


console.log({workStatus, apiStatus: attendanceData?.CurrentStatus,
  statusStartedAt,
});
// useEffect(() => {
//   if (!attendanceData) return;

//   setWorkingBaseSeconds(
//     hhmmToSeconds(attendanceData.TotalWorkingHours)
//   );

//   setBreakBaseSeconds(
//     hhmmToSeconds(attendanceData.BreakHours)
//   );
// }, [attendanceData]);

useEffect(() => {
  if (!attendanceData) return;

  const isClockedIn =
    !!attendanceData.IsClockedIn;

  const status =
    workStatus ||
    attendanceData.Status ||
    attendanceData.CurrentStatus;

  const isBreak =
    status === "Break" ||
    status === "Lunch" ||
    status === "Be Right Back" ||
    status === "Be right back" ||
    status === "On Hold";

  const apiWorkingSeconds =
    hhmmToSeconds(
      attendanceData.TotalWorkingHours
    );

  const apiBreakSeconds =
    hhmmToSeconds(
      attendanceData.BreakHours
    );

  const savedTimer =
    getTimerState();

  // =====================================================
  // CLOCKED OUT
  // =====================================================

  if (!isClockedIn) {
  const savedTimer = getTimerState();

  // ------------------------------------------------
  // Get the BEST available values
  // API may still be behind the UI by a few seconds.
  // ------------------------------------------------

  const finalWorking = Math.max(
    apiWorkingSeconds,
    workingSecondsRef.current,
    Number(savedTimer?.workingBaseSeconds || 0)
  );

  const finalBreak = Math.max(
    apiBreakSeconds,
    breakSecondsRef.current,
    Number(savedTimer?.breakBaseSeconds || 0)
  );

  // ------------------------------------------------
  // FREEZE BOTH TIMERS
  // ------------------------------------------------

  workingSecondsRef.current = finalWorking;
  breakSecondsRef.current = finalBreak;

  workingSegmentStartRef.current = null;
  breakSegmentStartRef.current = null;

  // ------------------------------------------------
  // SHOW FINAL VALUES
  // ------------------------------------------------

  setLiveWorking(
    secondsToHMS(finalWorking)
  );

  setLiveBreak(
    secondsToHMS(finalBreak)
  );

  setLiveWorkingSeconds(
    finalWorking
  );

  // ------------------------------------------------
  // NOW IT IS SAFE TO CLEAR LOCAL TIMER
  // ------------------------------------------------

  clearTimerState();

  return;
}
  // =====================================================
  // BREAK
  // =====================================================

  if (isBreak) {

    let workingBase =
      apiWorkingSeconds;

    let breakBase =
      apiBreakSeconds;

    let breakStart = null;

    // ---------------------------------------------------
    // RESTORE SAVED BREAK
    // ---------------------------------------------------

    if (
      savedTimer &&
      savedTimer.mode === "break"
    ) {

      workingBase =
        Math.max(
          apiWorkingSeconds,
          Number(
            savedTimer.workingBaseSeconds || 0
          )
        );

      breakBase =
        Math.max(
          apiBreakSeconds,
          Number(
            savedTimer.breakBaseSeconds || 0
          )
        );

      breakStart =
        Number(
          savedTimer.breakStart
        );
    }

    // ---------------------------------------------------
    // IMPORTANT:
    // If we are coming from WORKING,
    // freeze current working time FIRST.
    // ---------------------------------------------------

    if (
      workingSegmentStartRef.current &&
      (!savedTimer ||
        savedTimer.mode !== "break")
    ) {

      const currentWorking =
        getCurrentWorkingSeconds();

      workingBase =
        Math.max(
          workingBase,
          currentWorking
        );
    }

    // ---------------------------------------------------
    // START NEW BREAK
    // ---------------------------------------------------

    if (!breakStart) {

      breakStart =
        Date.now();

      saveTimerState({
        mode: "break",

        workingBaseSeconds:
          workingBase,

        breakBaseSeconds:
          breakBase,

        breakStart
      });
    }

    // ---------------------------------------------------
    // SET REFS
    // ---------------------------------------------------

   workingSecondsRef.current = Math.max(
  workingSecondsRef.current,
  workingBase
);

breakSecondsRef.current = Math.max(
  breakSecondsRef.current,
  breakBase
);
    workingSegmentStartRef.current =
      null;

    breakSegmentStartRef.current =
      breakStart;

    // ---------------------------------------------------
    // TIMER
    // ---------------------------------------------------

    const tick = () => {

      // Working is frozen
      setLiveWorking(
        secondsToHMS(
          workingBase
        )
      );

      setLiveWorkingSeconds(
        workingBase
      );

      // Break is running
      const breakElapsed =
        Math.floor(
          (
            Date.now() -
            breakStart
          ) / 1000
        );

      const totalBreak =
        breakBase +
        Math.max(
          0,
          breakElapsed
        );

      setLiveBreak(
        secondsToHMS(
          totalBreak
        )
      );
    };

    tick();

    const interval =
      setInterval(
        tick,
        1000
      );

    return () =>
      clearInterval(interval);
  }

  // =====================================================
  // WORKING / ACTIVE
  // =====================================================

  // -----------------------------------------------------
  // COUNT FROM SERVER-MEASURED ELAPSED SECONDS
  // -----------------------------------------------------
  // The server reports two numbers: WorkedSeconds (shifts already closed) and
  // OpenSeconds (how long the current shift had been running when it replied).
  // We show their sum and tick forward from the moment the reply arrived, so
  // the figure is identical on every machine and survives refreshes and tabs.
  //
  // Three earlier attempts failed here, all for the same underlying reason —
  // the number depended on something local rather than on the server:
  //   * base included the open shift AND we added it again  -> 00:28 vs a real 00:17
  //   * anchor fell back to page-load time on a fresh browser -> restarted at 00:00:31
  //   * anchor came from a timestamp, and the live API runs in UTC while a dev
  //     box runs in IST, so clock-in landed 5.5h in the future -> counter frozen
  // Elapsed seconds have no timezone and no dependence on this browser's state.

  const workedSec = Number(attendanceData?.WorkedSeconds);
  const openSec = Number(attendanceData?.OpenSeconds);
  const hasServerSeconds =
    Number.isFinite(workedSec) && Number.isFinite(openSec);

  // Fall back to the minute-precision fields if the API predates this.
  let workingBase = hasServerSeconds ? workedSec + openSec : apiWorkingSeconds;
  let breakBase = Number.isFinite(Number(attendanceData?.BreakSeconds))
    ? Number(attendanceData.BreakSeconds)
    : apiBreakSeconds;

  // Tick from when this reply landed, NOT from a wall-clock instant.
  let workingStart = Date.now();

  saveTimerState({
    mode: "working",
    workingBaseSeconds: workingBase,
    breakBaseSeconds: breakBase,
    workingStart
  });

  // -----------------------------------------------------
  // SET REFS
  // -----------------------------------------------------

  workingSecondsRef.current =
    workingBase;

  breakSecondsRef.current =
    breakBase;

  workingSegmentStartRef.current =
    workingStart;

  breakSegmentStartRef.current =
    null;

  // -----------------------------------------------------
  // TIMER
  // -----------------------------------------------------

const tick = () => {

  const workingElapsed = Math.floor(
    (Date.now() - workingStart) / 1000
  );

  const totalWorking =
    workingBase +
    Math.max(0, workingElapsed);

  setLiveWorking(
    secondsToHMS(totalWorking)
  );

  setLiveWorkingSeconds(
    totalWorking
  );

  setLiveBreak(
    secondsToHMS(breakBase)
  );
};

  tick();

  const interval =
    setInterval(
      tick,
      1000
    );

  return () =>
    clearInterval(interval);

}, [
  attendanceData?.IsClockedIn,
  attendanceData?.Status,
  attendanceData?.CurrentStatus,
  attendanceData?.TotalWorkingHours,
  attendanceData?.BreakHours,
  workStatus
]);

  const handleClockIn = async () => {
  if (clockBusyRef.current) return;

  clockBusyRef.current = true;

  try {
    const response = await dispatch(
      clockInEmployee(currentUser.userId)
    ).unwrap();

    toast.success(response.data.message);

    // =====================================
    // NEW DAY / NEW CLOCK-IN
    // =====================================

    const now = Date.now();

    workingSecondsRef.current = 0;
    breakSecondsRef.current = 0;

    workingSegmentStartRef.current = now;
    breakSegmentStartRef.current = null;

    saveTimerState({
  mode: "working",
  workingBaseSeconds: 0,
  workingStart: now,
});

    setLiveWorkingSeconds(0);
    setLiveWorking("00:00:00");
    setLiveBreak("00:00:00");

    // =====================================
    // REFRESH API DATA
    // =====================================

    await dispatch(
      getAttendanceDashboard()
    ).unwrap();

    await dispatch(
      getWorkingHours(currentUser.userId)
    ).unwrap();

  } catch (err) {
    workingSecondsRef.current = 0;
    breakSecondsRef.current = 0;

    workingSegmentStartRef.current = null;
    breakSegmentStartRef.current = null;

    toast.error(
      err?.message || "Clock In Failed"
    );
  } finally {
    clockBusyRef.current = false;
  }
};

const handleClockOut = async () => {
  if (clockBusyRef.current) return;

  clockBusyRef.current = true;

  try {
    // =====================================
    // FREEZE CURRENT WORKING TIMER
    // =====================================

    // workingSecondsRef.current already contains
    // the latest live working value.
    const finalWorkingSeconds = Math.max(
      workingSecondsRef.current, getCurrentWorkingSeconds()
    );

    console.log("CLOCK OUT FINAL WORKING", finalWorkingSeconds);

    // =====================================
    // SAVE EXACT FROZEN VALUE
    // =====================================

    workingSecondsRef.current = finalWorkingSeconds;

    frozenWorkingSecondsRef.current = finalWorkingSeconds;

    // =====================================
    // STOP ALL LIVE TIMERS
    // =====================================

    workingSegmentStartRef.current = null;
    breakSegmentStartRef.current = null;

    timerModeRef.current = "frozen";

    // =====================================
    // FREEZE UI AT EXACT CURRENT VALUE
    // =====================================

    setLiveWorking(
      secondsToHMS(finalWorkingSeconds)
    );

    setLiveWorkingSeconds(
      finalWorkingSeconds
    );

    // =====================================
    // CLOCK OUT API
    // =====================================

    const response = await dispatch(
      clockOutEmployee(currentUser.userId)
    ).unwrap();

    toast.success(
      response?.data?.message ||
      "Clock Out Successful"
    );

    // =====================================
    // MARK CLOCKED OUT
    // =====================================

    setIsClockedIn(false);

    // =====================================
    // REFRESH DASHBOARD
    // =====================================

    await dispatch(
      getAttendanceDashboard()
    ).unwrap();

  } catch (err) {

    console.error(
      "Clock Out Error:",
      err
    );

    toast.error(
      err?.message ||
      "Clock Out Failed"
    );

  } finally {

    clockBusyRef.current = false;
  }
};

  // REFS
  /* Company Status Overview, by client or by project.
   *
   * The same figures counted a different way, not a different report — most
   * clients sit under TEXTILE INDUSTRY, and by client that shared work is
   * spread across twenty rows nobody can add up. Fetched once when the panel
   * first needs it rather than on every dashboard load, since the client view
   * is the one that opens. */
  const [overviewBy, setOverviewBy] = useState("company");
  const [projectRows, setProjectRows] = useState([]);
  const lastRequestRef = useRef(null);
  const clockRequestRef = useRef(null);
  const clockBusyRef = useRef(false); // prevents double-firing clock in/out
  const realCardRef = useRef(null);
  const celebrationCardRef = useRef(null);

  // COLORS
  const colors = {
    primaryBlue: "#3b82f6",
    red: "rgb(211, 47, 47)",
    orange: "rgb(245, 124, 0)",
    successGreen: "#10B981",
    teal: "#20c997",
  };

  // --- HELPER FUNCTIONS ---
  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.split(" ");
    return parts.length > 1
      ? (parts[0][0] + parts[1][0]).toUpperCase()
      : name.slice(0, 2).toUpperCase();
  };

  const calculateEfficiency = (user) => {
    if (!user || !user.Total_Nos || user.Total_Nos === 0) return 0;
    const penalty = user.Bug_Nos * 15 + user.Rework_Nos * 10;
    let eff = 100 - (penalty / (user.Total_Nos || 1)) * 5;
    return Math.max(Math.min(Math.round(eff), 100), 0);
  };

  const handleDateChange = (start, end) => {
    const formatDate = (d) =>
      d ? new Date(d).toISOString().split("T")[0] : null;
    setDateRange({ start: formatDate(start), end: formatDate(end) });
  };

  // --- EFFECTS ---
  useEffect(() => {
    if (animationStage === "celebrating") {
      localStorage.setItem("dashboard_animation_played", "true");
    }
  }, [animationStage]);
  /* Coming back to the Dashboard re-pulls it.
   *
   * The pane stays mounted while another tab is on screen, so the fetch
   * effect below — keyed on the date range — never fires again on its own.
   * A dashboard is the one screen where that matters: it is read for what is
   * true NOW, and it was showing whatever was true when the tab was first
   * opened, however many hours ago. Clock Status and Working On Now were the
   * worst of it — a roster of who is at their desk, frozen since breakfast.
   *
   * lastRequestRef is cleared first because it exists to stop the same window
   * being fetched twice; here fetching the same window again is the entire
   * point, so the guard has to stand down rather than swallow the refresh. */
  const refreshDashboard = useCallback(() => {
    lastRequestRef.current = null;

    if (dateRange.start && dateRange.end) {
      const payload = { fromDate: dateRange.start, toDate: dateRange.end };
      lastRequestRef.current = JSON.stringify(payload);

      dispatch(dashboardClientStatusListsApis(payload));
      dispatch(dashboardQueryTypeListsApis(payload));
      dispatch(dashboardSummaryListsApis(payload));
      dispatch(dashboarUserStatusListsApis(payload));
      dispatch(dashboardQueriesCountAndProductivityStarApis(payload));
    }

    /* The roster — who is at their desk right now — which is the panel that
       goes stalest and the reason to refresh at all. Working On Now is not
       here because ActiveTasksPanel already polls on its own timer. */
    dispatch(getTeamClockStatus());

    if (currentUser?.userId) {
      dispatch(getWorkingHours(currentUser.userId));
      dispatch(getAttendanceDashboard());
    }
  }, [dispatch, dateRange.start, dateRange.end, currentUser?.userId]);

  useTabRefresh(refreshDashboard);

  useEffect(() => {
    if (overviewBy !== "project" || projectRows.length) return undefined;
    let alive = true;
    dispatch(summaryByProjectApis({}))
      .unwrap()
      .then((res) => {
        if (!alive) return;
        const body = res?.data ?? res;
        const inner = body?.data ?? body;
        setProjectRows(Array.isArray(inner) ? inner : []);
      })
      .catch(() => alive && setProjectRows([]));
    return () => {
      alive = false;
    };
  }, [overviewBy, projectRows.length, dispatch]);

  // Main Fetch Effect
  useEffect(() => {
    if (dateRange.start && dateRange.end) {
      const payload = { fromDate: dateRange.start, toDate: dateRange.end };
      const requestKey = JSON.stringify(payload);
      if (lastRequestRef.current === requestKey) return;
      lastRequestRef.current = requestKey;

      dispatch(dashboardClientStatusListsApis(payload));
      dispatch(dashboardQueryTypeListsApis(payload));
      dispatch(dashboardSummaryListsApis(payload));
      dispatch(dashboarUserStatusListsApis(payload));
      dispatch(dashboardQueriesCountAndProductivityStarApis(payload));
      // dispatch(clockInEmployee(payload));
      // dispatch(clockOutEmployee(payload));
      // dispatch(getWorkingHours(payload));
    }
    if (currentUser?.userId) {
      // Read-only fetches to populate the attendance card. These depend only on
      // the user id (not the date range), so fire once per user.
      // NOTE: clock-in / clock-out are POST actions that punch attendance — they
      // must ONLY run on button click, never on mount/refresh.
      const userKey = String(currentUser.userId);
      if (clockRequestRef.current !== userKey) {
        clockRequestRef.current = userKey;
        dispatch(getWorkingHours(currentUser.userId));
        dispatch(getAttendanceDashboard());
      }
    }
  }, [dispatch, dateRange.start, dateRange.end, currentUser?.userId]);

  /* Who is in and who is out, for the day the picker ends on.
     The end of the range rather than the start: the clock is a "right now"
     question, and over a range the most recent day is the one that answers
     it. Its own effect because it is the only fetch keyed on one date. */
  useEffect(() => {
    dispatch(
      getTeamClockStatus(
        dateRange.end ? { onDate: toApiDay(dateRange.end) } : undefined,
      ),
    );
  }, [dispatch, dateRange.end]);

  /* Break Hours by reason, over the whole selected range — the card's own
     total already covers that range, and a split that covered a different
     window would not add up to the number printed above it. */
  useEffect(() => {
    dispatch(
      getBreakBreakdown(
        dateRange.start && dateRange.end
          ? { fromDate: toApiDay(dateRange.start), toDate: toApiDay(dateRange.end) }
          : undefined,
      ),
    );
  }, [dispatch, dateRange.start, dateRange.end]);

  useEffect(() => {
    if (
      userStatusLists &&
      Array.isArray(userStatusLists) &&
      userStatusLists.length > 0
    ) {
      setLiveTeamStatus(userStatusLists);
    }
  }, [userStatusLists]);

  useEffect(() => {
    console.log("queriesCountAndProductivityData:", queriesCountAndProductivityData);
    const nestedData = queriesCountAndProductivityData?.data?.data
      || queriesCountAndProductivityData?.data
      || queriesCountAndProductivityData;

    if (nestedData && nestedData.productivityStar) {
      setYesterdayPerformer(nestedData.productivityStar);
    } else {
      setYesterdayPerformer(null);
    }
  }, [queriesCountAndProductivityData]);

  // --- SMOOTH ANIMATION LOGIC ---
  useEffect(() => {
    if (animationStage === "celebrating" && yesterdayPerformer) {
      const timer = setTimeout(() => {
        if (!realCardRef.current || !celebrationCardRef.current) return;

        const destRect = realCardRef.current.getBoundingClientRect();
        const srcRect = celebrationCardRef.current.getBoundingClientRect();

        const deltaX = destRect.left - srcRect.left;
        const deltaY = destRect.top - srcRect.top;

        setFlyStyles({
          transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(1)`,
          width: `${destRect.width}px`,
          height: `${destRect.height}px`,
          margin: 0,
        });

        setAnimationStage("flying");

        setTimeout(() => setAnimationStage("finished"), 800);
      }, 2500);

      return () => clearTimeout(timer);
    }
  }, [yesterdayPerformer, animationStage]);

  // --- KPI STATS ---
  const kpiStats = useMemo(() => {
    const safeSummary = Array.isArray(summaryLists) ? summaryLists : [];
    const safeQueryType = Array.isArray(queryTypeList) ? queryTypeList : [];
    const grandTotalRow =
      safeSummary.find((item) => item.CompanyName === "GRAND TOTAL") || {};
    const totalBugs = safeQueryType.reduce(
      (acc, user) => acc + (user.Bug_Nos || 0),
      0
    );
    const totalReworks = safeQueryType.reduce(
      (acc, user) => acc + (user.Rework_Nos || 0),
      0
    );
    const totalNewTasks = safeQueryType.reduce(
      (acc, user) => acc + (user.NewTask_Nos || 0),
      0
    );

    return {
      totalQueries: grandTotalRow.Total_Nos || 0,
      completed: grandTotalRow.Complete_Nos || 0,
      inProgress: grandTotalRow.InProgress_Nos || 0,
      onHold: grandTotalRow.OnHold_Nos || 0,
      bugs: totalBugs,
      reworks: totalReworks,
      newTasks: totalNewTasks,
      avgTime: "4h 30m",
      age02: grandTotalRow.Age_0_2 || 0,
      age35: grandTotalRow.Age_3_5 || 0,
      age6Plus: grandTotalRow.Age_6_Plus || 0,
    };
  }, [summaryLists, queryTypeList]);

  const companyList = useMemo(() => {
    if (!Array.isArray(summaryLists)) return [];
    return summaryLists.filter(
      (item) =>
        item.CompanyName &&
        item.CompanyName !== "GRAND TOTAL" &&
        item.CompanyName !== ""
    );
  }, [summaryLists]);

  /* The Total row under Company Status Overview.
   *
   * Summed from companyList — the rows on screen — rather than taken from the
   * GRAND TOTAL row the procedure already returns. Those two are not the same
   * number: sp_Sky_DashBoard_Summary totals the whole view, while the list
   * above drops any row with a blank CompanyName, so the procedure's figure
   * can be larger than anything the reader can add up. A totals row that does
   * not equal the column above it reads as an error in the table, whichever
   * of the two is "right" in the abstract.
   *
   * Company count rather than row count in the first cell: the rows are
   * companies, and a few of them appear twice because the procedure groups by
   * isManuallyRaised as well as by name — so "48 rows" would be a number
   * nobody could reconcile with the names they can see. */
  const companyTotals = useMemo(() => {
    /* Always the leaf rows — a grouped view must not add the headings in as
       well, or every figure would be counted twice. */
    const rows = overviewBy === "project" ? projectRows : companyList;
    const sum = (key) => rows.reduce((n, c) => n + (Number(c[key]) || 0), 0);

    const companies = new Set(rows.map((c) => c.CompanyName)).size;

    /* The age columns average, the status columns total.
     *
     * The two halves of this table answer different questions. Complete /
     * Not Started / In Progress / On Hold are a workload — "how much is
     * there" — and a workload adds up. The age buckets are a shape: how old
     * the backlog runs. Added up they only restate the workload from a
     * second angle, and 4,294 in the 6+ column says nothing you could act on.
     * Per company it becomes a figure a row can be read against — this
     * client is above the line, that one is under it.
     *
     * Divided by companies, not by rows: a few names appear twice because
     * the procedure groups by isManuallyRaised as well as by name, so the
     * row count would quietly deflate every average. It is also the number
     * printed beside the word Total, so the arithmetic can be checked. */
    const avg = (key) => (companies ? sum(key) / companies : 0);

    return {
      companies,
      Complete_Nos: sum("Complete_Nos"),
      PrevCompleted: sum("PrevCompleted"),
      Pending:
        sum("NotStarted_Nos") + sum("InProgress_Nos") + sum("OnHold_Nos"),
      TodayCompleted: sum("TodayCompleted"),
      NotStarted_Nos: sum("NotStarted_Nos"),
      InProgress_Nos: sum("InProgress_Nos"),
      OnHold_Nos: sum("OnHold_Nos"),
      Age_0_2: sum("Age_0_2"),
      Age_3_5: sum("Age_3_5"),
      Age_6_Plus: sum("Age_6_Plus"),
      Age_0_2_Avg: avg("Age_0_2"),
      Age_3_5_Avg: avg("Age_3_5"),
      Age_6_Plus_Avg: avg("Age_6_Plus"),
    };
  }, [companyList, projectRows, overviewBy]);

  /* Frozen at the foot of the scroller, and it has to be the CELLS that
     freeze — `.clean-table td` sets its own white background, which paints
     straight over anything put on the <tr>, and a sticky <tr> is the same
     browser lottery a sticky <thead> is.

     The shadow covers the 10px the table leaves between rows; without it a
     row shows through the gap under the totals. */

  /* One decimal, always — including on a whole number. An average printed as
     "5" beside one printed as "2.7" reads as a count that happens to be
     round, which is the one thing these three cells must not be mistaken
     for. A dash when there is nothing to average, matching the rows above. */
  const formatAvg = (value, total) =>
    total > 0 ? value.toFixed(1) : "-";

  /* What the overview table renders.
   *
   * Client wise is a flat list. Project wise is the same clients GROUPED: a
   * heading per project carrying the sum of the rows beneath it, then those
   * rows. Grouped rather than replaced by project totals, because the
   * question the card gets asked is "how is TEXTILE INDUSTRY doing, and which
   * of its twenty clients is the problem" — a total alone answers half of it
   * and sends you elsewhere for the rest.
   *
   * Emitted as one flat list of { kind } entries so the table body stays a
   * single map; a nested render would need a fragment per project and lose
   * the striping. */
  const overviewRows = useMemo(() => {
    if (overviewBy !== "project") {
      return companyList.map((row) => ({ kind: "row", row }));
    }

    const byProject = new Map();
    projectRows.forEach((r) => {
      const key = r.ProjectName || "(no project)";
      if (!byProject.has(key)) byProject.set(key, []);
      byProject.get(key).push(r);
    });

    const NUMERIC = [
      "PrevCompleted",
      "TodayCompleted",
      "NotStarted_Nos",
      "InProgress_Nos",
      "OnHold_Nos",
      "Age_0_2",
      "Age_3_5",
      "Age_6_Plus",
      "Complete_Nos",
    ];

    const out = [];
    [...byProject.keys()]
      .sort((a, b) => a.localeCompare(b))
      .forEach((project) => {
        const rows = byProject
          .get(project)
          .sort((a, b) =>
            String(a.CompanyName).localeCompare(String(b.CompanyName)),
          );

        const totals = { ProjectName: project, Clients: rows.length };
        NUMERIC.forEach((k) => {
          totals[k] = rows.reduce((n, r) => n + (Number(r[k]) || 0), 0);
        });

        out.push({ kind: "group", row: totals });
        rows.forEach((row) => out.push({ kind: "row", row }));
      });

    return out;
  }, [overviewBy, companyList, projectRows]);

  // Top 5 clients by total activity, feeds the Top Client Activity bar chart.
  const topClients = useMemo(() => {
    return [...clientStatusData]
      .filter((c) => c.Total_Nos > 0)
      .sort((a, b) => b.Total_Nos - a.Total_Nos)
      .slice(0, 5);
  }, [clientStatusData]);

  // Top Client Activity — clean horizontal stacked bar (validated categorical palette:
  // New Tasks = blue, Bugs = red, Reworks = amber). Horizontal so long client names read well.
  // Top Client Activity — overall split of New Tasks / Bugs / Reworks across the
  // top clients, shown as a doughnut (validated palette: blue / red / amber).
  const clientActivityChartData = useMemo(() => {
    const totals = topClients.reduce(
      (acc, c) => ({
        NewTask_Nos: acc.NewTask_Nos + (c.NewTask_Nos || 0),
        Bug_Nos: acc.Bug_Nos + (c.Bug_Nos || 0),
        Rework_Nos: acc.Rework_Nos + (c.Rework_Nos || 0),
      }),
      { NewTask_Nos: 0, Bug_Nos: 0, Rework_Nos: 0 }
    );

    return {
      labels: ["New Tasks", "Bugs", "Reworks"],
      datasets: [
        {
          data: [totals.NewTask_Nos, totals.Bug_Nos, totals.Rework_Nos],
          backgroundColor: ["#3b82f6", "#ef4444", "#f59e0b"],
          borderColor: "#fff",
          borderWidth: 3,
          hoverOffset: 10,
        },
      ],
    };
  }, [topClients]);

  const lineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { stacked: true, grid: { display: false } },
      y: { stacked: true, grid: { borderDash: [4, 4], color: "#f0f0f0" } },
    },
  };

  const [selectedClient, setSelectedClient] = useState("");

  const companyOverviewChartData = useMemo(() => {
    if (!clientStatusData.length) {
      return {
        labels: [],
        datasets: [],
      };
    }
    console.log(selectedClient)
    const companyRows = clientStatusData.filter(
      (c) => c.ClientName == selectedClient
    );

    if (companyRows.length == 0) {
      return {
        labels: [],
        datasets: [],
      };
    }

    const company = companyRows.reduce(
      (acc, item) => ({
        NewTask_Nos: acc.NewTask_Nos + item.NewTask_Nos,
        Bug_Nos: acc.Bug_Nos + item.Bug_Nos,
        Rework_Nos: acc.Rework_Nos + item.Rework_Nos,
      }),
      {
        NewTask_Nos: 0,
        Bug_Nos: 0,
        Rework_Nos: 0,
      }
    );
    console.log("Company Rows:", companyRows);
    console.log("Selected Client:", selectedClient);

    return {
      labels: ["New Tasks", "Bugs", "Reworks"],
      datasets: [
        {
          data: [
            company.NewTask_Nos,
            company.Bug_Nos,
            company.Rework_Nos
          ],
          backgroundColor: [
            "#3b82f6",
            "#ef4444",
            "#f59e0b",
          ],
          borderColor: "#fff",
          borderWidth: 3,
          hoverOffset: 10,
        },
      ],
    };
  }, [clientStatusData, selectedClient]);

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "68%",
    plugins: {
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 18,
          color: "#475569",
          font: { size: 13, family: "'Inter', sans-serif" },
        },
      },
      tooltip: {
        backgroundColor: "#1f2937",
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 12,
        cornerRadius: 8,
        usePointStyle: true,
        boxPadding: 6,
        callbacks: {
          // Show count and share of the total, e.g. "New Tasks: 24 (78%)"
          label: (ctx) => {
            const data = ctx.dataset.data || [];
            const total = data.reduce((a, b) => a + (Number(b) || 0), 0);
            const val = Number(ctx.parsed) || 0;
            const pct = total ? Math.round((val / total) * 100) : 0;
            return ` ${ctx.label}: ${val} (${pct}%)`;
          },
        },
      },
    },
  }

  const workloadChartData = {
    labels: Array.isArray(queryTypeList)
      ? queryTypeList.map((p) => p.UserName)
      : [],
    datasets: [
      {
        label: "New Tasks",
        data: Array.isArray(queryTypeList)
          ? queryTypeList.map((p) => p.NewTask_Nos)
          : [],
        backgroundColor: colors.primaryBlue,
        borderRadius: 4,
        barThickness: 15,
      },
      {
        label: "Bugs",
        data: Array.isArray(queryTypeList)
          ? queryTypeList.map((p) => p.Bug_Nos)
          : [],
        backgroundColor: colors.red,
        borderRadius: 4,
        barThickness: 15,
      },
      {
        label: "Reworks",
        data: Array.isArray(queryTypeList)
          ? queryTypeList.map((p) => p.Rework_Nos)
          : [],
        backgroundColor: colors.orange,
        borderRadius: 4,
        barThickness: 15,
      },
    ],
  };


  const { workingUsers, idleUsers } = useMemo(() => {
    const working = liveTeamStatus.filter((u) => u.ClientName !== null);
    const idle = liveTeamStatus.filter(
      (u) => u.ClientName === null && u.UserName !== "SUPER_ADMIN"
    );
    return { workingUsers: working, idleUsers: idle };
  }, [liveTeamStatus]);

  if (pageLoading) {
    return <Loader inline variant="dashboard" />;
  }
  return (

    <div className="modern-dashboard">
      {/* CELEBRATION OVERLAY */}
      {animationStage !== "finished" && yesterdayPerformer && (
        <div
          className={`celebration-overlay ${animationStage === "flying" ? "overlay-hidden" : ""
            }`}
        >
          <div className="celebration-content">
            <h1
              className={`congrats-text ${animationStage === "flying" ? "fade-out" : ""
                }`}
            >
              🎉 Yesterday's Top Performer 🎉
            </h1>
            <div
              ref={celebrationCardRef}
              className="celebration-card-wrapper"
              style={animationStage === "flying" ? flyStyles : {}}
            >
              <div
                className="profile-card"
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "380px",
                  boxShadow: "none",
                  border: "none",
                }}
              >
                <div className="profile-header">
                  <span>Productivity Star</span>
                  <BsTrophyFill className="text-warning" size={24} />
                </div>
                <ProfileCardInner
                  bestPerformer={yesterdayPerformer}
                  colors={colors}
                  calculateEfficiency={calculateEfficiency}
                  getInitials={getInitials}
                  isAnimated={false}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* HEADER (Always visible) */}
      <div className="dash-header">
        <div>
          <h2 className="dash-title">Dashboard Overview</h2>
          <p className="dash-subtitle">
            Real-time insights into your team's performance.
          </p>
        </div>
        <div className="dash-actions">
          <DateRangeFilter
            startDate={dateRange.start}
            endDate={dateRange.end}
            onChange={handleDateChange}
          />
        </div>
      </div>
      <ClocksCard
        firstClockIn={attendanceData?.FirstClockIn || "--:--"}
        clockIn={attendanceData?.RecentClockIn || "--:--"}
        clockOut={attendanceData?.RecentClockOut || "--:--"}
        workingHours={liveWorking}
        breakHours={liveBreak}
        breakBreakdown={breakBreakdown}
        lastLoginAt={lastLoginAt}
        todayDate={todayDate?.date}
        isClockIn={isClockedIn}
        onClockIn={handleClockIn}
        onClockOut={handleClockOut}
        loading={dashboardStatus === "loading"}
      />

      {/* CUSTOM LOADER 2: MAIN DASHBOARD LOADER
        Hides the dashboard and shows the loader while API requests are running 
      */}


      {dashboardStatus === "loading" && !clientStatusData.length ? (
        <Loader inline variant="dashboard" />
      ) : (
        <>
          {/* KPI GRID */}
          <div className="kpi-grid">
            <div
              ref={realCardRef}
              className={`profile-card real-card ${animationStage === "finished" ? "visible" : ""
                }`}
            >
              <div className="profile-header">
                <span>Productivity Star</span>
                <BsTrophyFill className="text-warning" />
              </div>
              <ProfileCardInner
                bestPerformer={yesterdayPerformer}
                colors={colors}
                calculateEfficiency={calculateEfficiency}
                getInitials={getInitials}
              />
            </div>
            <div className="gradient-card grad-orange delay-1">
              <div className="g-card-header">
                <span className="g-card-title text-danger">Total Queries</span>
                <div className="g-icon-box">
                  <BsFileEarmarkPlusFill />
                </div>
              </div>
              <h2 className="g-card-value">
                <AnimatedCounter value={kpiStats.totalQueries} />
              </h2>
              <div className="g-card-footer">{kpiStats.completed} Completed</div>
            </div>
            <div className="gradient-card grad-blue delay-2">
              <div className="g-card-header">
                <span className="g-card-title text-purple">Total Bugs</span>
                <div className="g-icon-box">
                  <BsBugFill />
                </div>
              </div>
              <h2 className="g-card-value">
                <AnimatedCounter value={kpiStats.bugs} />
              </h2>
              <div className="g-card-footer">{kpiStats.reworks} Reworks</div>
            </div>
            <div className="gradient-card grad-green delay-3">
              <div className="g-card-header">
                <span className="g-card-title text-success">Avg. Time</span>
                <div className="g-icon-box icon-green">
                  <i className="bi bi-clock-fill"></i>
                </div>
              </div>
              <h2 className="g-card-value">{kpiStats.avgTime}</h2>
              <div className="g-card-footer">On Track</div>
            </div>
            <div className="gradient-card grad-teal delay-4">
              <div className="g-card-header">
                <span className="g-card-title blue-text">Total New Tasks</span>
                <div className="g-icon-box">
                  <i className="bi bi-list-task"></i>
                </div>
              </div>
              <h2 className="g-card-value">
                <AnimatedCounter value={kpiStats.newTasks} />
              </h2>
              <div className="g-card-footer">Assigned</div>
            </div>
            <div className="gradient-card grad-red delay-5">
              <div className="g-card-header">
                <span className="g-card-title text-pink">Total Reworks</span>
                <div className="g-icon-box">
                  <i className="bi bi-arrow-repeat"></i>
                </div>
              </div>
              <h2 className="g-card-value">
                <AnimatedCounter value={kpiStats.reworks} />
              </h2>
              <div className="g-card-footer">Needs Attention</div>
            </div>
            <div className="gradient-card grad-yellow delay-6">
              <div className="g-card-header">
                <span className="g-card-title text-orange">On Hold</span>
                <div className="g-icon-box">
                  <i className="bi bi-pause-circle-fill"></i>
                </div>
              </div>
              <h2 className="g-card-value">
                <AnimatedCounter value={kpiStats.onHold} />
              </h2>
              <div className="g-card-footer">Pending Review</div>
            </div>
          </div>

          {/* --- TEAM WORKLOAD --- */}
          <TeamWorkloadPanel />

          {/* --- MIDDLE SECTION --- */}
          <div
            className="d-flex gap-3 align-items-stretch cards"
            style={{ flexWrap: "wrap" }}
          >
            <div
              className="content-card d-flex flex-column"
              style={{ flex: "1.5", height: "400px" }}
            >
              <div className="card-header-custom">
                <h5 style={{ color: "#333fad" }}>Top Client Activity</h5>

                <div className="d-flex align-items-center gap-3 display">
                  <SkSelect
                    width={180}
                    placeholder="Select Company"
                    value={selectedClient}
                    options={[
                      ...new Set(clientStatusData.map((x) => x.ClientName)),
                    ].map((name) => ({ value: name, label: name }))}
                    onChange={setSelectedClient}
                    ariaLabel="Select company"
                  />

                  {selectedClient && (
                    <button
                      className="btn-icon"
                      onClick={() => setSelectedClient("")}
                    >
                      ←
                    </button>
                  )}
                </div>
              </div>

              <div
                className="flex-grow-1 d-flex justify-content-center cards"
                style={{ height: "350px", width: "100%", paddingLeft: "0", paddingRight: "0" }}
              >
                {!selectedClient ? (

                  <div style={{ width: "100%", height: "100%" }}>
                    <Doughnut
                      data={clientActivityChartData}
                      options={doughnutOptions}
                    />
                  </div>
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "350px",
                      }}
                    >
                      <Doughnut
                        data={companyOverviewChartData}
                        options={doughnutOptions}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>


            <div className="content-card" style={{
              flex: 1.4,
              height: "400px",
              maxWidth: "650px"
            }}>
              <div className="card-header-custom">
                <h5 style={{ color: "#333fad" }}>Team Performance</h5>
              </div>
              <div
                className="table-scroll-section"
                style={{ maxHeight: "320px", overflowY: "auto" }}
              >
                <table className="clean-table" style={{ width: "100%" }}>
                  {/* Sticky lives in dashboard.css on the cells — see
                      .clean-table thead th. */}
                  <thead>
                    <tr>
                      <th style={{ width: "140px", color: "black" }}>Employee</th>
                      <th style={{ color: "black" }}>Work Distribution</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...queryTypeList]
                      .sort((a, b) => calculateEfficiency(a) - calculateEfficiency(b))
                      .map((person, index) => {
                        const efficiency = calculateEfficiency(person);

                        const total =
                          person.Bug_Nos +
                          person.Rework_Nos +
                          person.NewTask_Nos;

                        const bugWidth = total ? (person.Bug_Nos / total) * 100 : 0;
                        const reworkWidth = total ? (person.Rework_Nos / total) * 100 : 0;
                        const taskWidth = total ? (person.NewTask_Nos / total) * 100 : 0;

                        let progressColor =
                          efficiency >= 90
                            ? colors.successGreen
                            : efficiency < 50
                              ? colors.red
                              : colors.primaryBlue;
                        return (
                          <tr key={index}>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div className="avatar-circle">
                                  {getInitials(person.UserName)}
                                </div>
                                <div>
                                  <div className="fw-bold text-dark small">
                                    {person.UserName}
                                  </div>
                                  {/* Was the literal word "Developer" for
                                      everybody — the row never read a role at
                                      all. Team sits alongside it because the
                                      card is called Team Performance. */}
                                  <div
                                    className="text-muted small d-flex align-items-center gap-1 flex-wrap"
                                    style={{ fontSize: "0.7rem" }}
                                  >
                                    <span>{formatRole(person.Role) || "—"}</span>
                                    {person.TeamName && (
                                      <>
                                        <span className="opacity-50">·</span>
                                        <span>{person.TeamName}</span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </td>


                            <td>
                              <div className="d-flex align-items-center gap-3">

                                <div className="stack-progress">

                                  {/* Bugs */}
                                  <div
                                    className="bug-stack"
                                    style={{ width: `${bugWidth}%` }}
                                    title={`🐞 Bugs : ${person.Bug_Nos}`}
                                  ></div>

                                  {/* Rework */}
                                  <div
                                    className="rework-stack"
                                    style={{ width: `${reworkWidth}%` }}
                                    title={`🔁 Rework : ${person.Rework_Nos}`}
                                  ></div>

                                  {/* Tasks */}
                                  <div
                                    className="task-stack"
                                    style={{ width: `${taskWidth}%` }}
                                    title={`📋 Tasks : ${person.NewTask_Nos}`}
                                  ></div>

                                </div>

                                <small className="fw-bold">
                                  {efficiency}%
                                </small>

                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>





            <div className="content-card" style={{ flex: "1", height: "400px" }}>
              <div className="card-header-custom">
                <h5 className="d-flex align-items-center gap-2" style={{ color: "#333fad" }}>
                  Live Team Status
                </h5>
                <BsPersonCheckFill className="text-primary opacity-50" size={20} />
              </div>
              <div className="d-flex gap-4 border-bottom px-3 pt-2 mb-2">
                <div
                  style={{ cursor: "pointer" }}
                  className={`cursor-pointer pb-2 small ${activeTab === "idle"
                    ? "border-bottom border-3 border-primary text-primary fw-bold"
                    : "text-muted"
                    }`}
                  onClick={() => setActiveTab("idle")}
                >
                  Idle / Available ({idleUsers.length})
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  className={`cursor-pointer pb-2 small ${activeTab === "working"
                    ? "border-bottom border-3 border-primary text-primary fw-bold"
                    : "text-muted"
                    }`}
                  onClick={() => setActiveTab("working")}
                >
                  Working Now ({workingUsers.length})
                </div>
              </div>
              <div
                className="attendance-container d-flex flex-column flex-grow-1"
                style={{ overflowY: "auto", maxHeight: "350px" }}
              >
                {activeTab === "working" ? (
                  <div className="user-status-list">
                    {workingUsers.length > 0 ? (
                      workingUsers.map((user, idx) => (
                        <div
                          key={idx}
                          className="user-status-item p-2 mb-2 border rounded bg-light d-flex flex-column"
                        >
                          <div className="d-flex align-items-center justify-content-between w-100">
                            <div
                              className="d-flex align-items-center gap-2"
                              style={{ marginRight: "auto" }}
                            >
                              <div
                                className="user-avatar-sm flex-shrink-0"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  fontSize: "10px",
                                }}
                              >
                                {getInitials(user.UserName)}
                              </div>
                              <span
                                className="fw-bold text-dark"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {user.UserName}
                              </span>
                            </div>
                            <div
                              className="text-primary small mx-2 d-none d-sm-block text-truncate"
                              style={{ maxWidth: "120px" }}
                              title={user.ClientName}
                            >
                              <BsBuilding className="me-1" />
                              {user.ClientName}
                            </div>
                            <div className="flex-shrink-0">
                              <span
                                className="badge bg-white text-success border border-success border-opacity-25 rounded-pill px-2"
                                style={{ fontWeight: "600" }}
                              >
                                <BsStopwatch className="me-1" />
                                {user.RunningTime
                                  ? user.RunningTime.replace("0 Days ", "")
                                  : "00:00"}
                              </span>
                            </div>
                          </div>
                          <div className="d-block d-sm-none mt-1">
                            <span className="text-primary small">
                              <BsBuilding className="me-1" />
                              {user.ClientName}
                            </span>
                          </div>
                          {user.NatureofQuery && (
                            <div
                              className="mt-2 pt-1 border-top border-light text-muted small w-100"
                              style={{
                                display: "block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                cursor: "pointer",
                                fontSize: "0.75rem",
                              }}
                              title={user.NatureofQuery}
                            >
                              {user.NatureofQuery}
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="text-center p-4 text-muted">
                        <small>No one is working currently.</small>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="user-status-list p-2">
                    {idleUsers.length > 0 ? (
                      <div className="d-flex flex-column gap-2">
                        {idleUsers.map((user, idx) => (
                          <div
                            key={idx}
                            className="d-flex align-items-center justify-content-between p-2 border rounded bg-white"
                          >
                            <div className="d-flex align-items-center gap-2">
                              <div
                                className="user-avatar-sm"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  fontSize: "10px",
                                  background: "#f3f4f6",
                                  color: "#6b7280",
                                }}
                              >
                                {getInitials(user.UserName)}
                              </div>
                              <span className="fw-medium text-dark">
                                {user.UserName}
                              </span>
                            </div>
                            <span className="badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-10 rounded-pill px-2">
                              <BsCircleFill
                                size={6}
                                className="me-1 text-secondary"
                              />
                              Idle
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center p-4 text-muted fst-italic">
                        <small>Everyone is currently working!</small>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Who is at their desk. Beside Live Team Status rather than
                merged into it because they answer different questions: that
                one lists who has a task running, this one who is on the
                clock. Somebody can be clocked in with nothing started, or
                still hold an open task after punching out — so the two lists
                genuinely differ, and merging them would force a wrong answer
                to one of the two. */}
            <ClockRosterPanel
              rows={teamClock.rows}
              counts={teamClock.counts}
              loading={teamClockLoading}
            />
          </div>

          {/* What is actually being worked on, under who is at their desk.
              Clock Status says who is here; this says what they are on and
              whether it is running past its estimate — the question a lead
              asks straight after "who is in". */}
          {/* Today split into work and breaks, immediately above the panel
              that says what the work currently is. */}
          <DaySpellsStrip />

          <div
            className="d-flex gap-3 align-items-stretch cards"
            style={{ flexWrap: "wrap" }}
          >
            <ActiveTasksPanel />
          </div>

          {/* --- BOTTOM ROW --- */}


          {/* <div className="vertical-stack" style={{ flex: 1 }}> */}
          {/* <div className="content-card"> */}
          {/* <div className="card-header-custom">
                  <h5>Daily Workload</h5>
                </div> */}
          {/* <div style={{ height: "180px", position: "relative" }}>
                  <Bar
                    data={workloadChartData}
                    options={{
                      ...lineOptions,
                      plugins: { legend: { display: false } },
                    }}
                  />
                </div> */}
          {/* </div> */}
          {/* <div
                className="content-card d-flex flex-column"
                style={{ height: "450px" }}
              >
                <div className="card-header-custom d-flex justify-content-between align-items-center">
                  <h5>Team Attendance</h5>
                  <BsPersonBadge className="text-primary opacity-50" size={24} />
                </div>
                <div
                  className="flex-grow-1 p-3 overflow-auto"
                  style={{ minHeight: 0 }}
                >
                  <div className="text-success small fw-bold mb-2">
                    ACTIVE TODAY ({workingUsers.length})
                  </div>
                  <div className="d-flex flex-column gap-2">
                    {workingUsers.map((emp, i) => (
                      <div
                        key={i}
                        className="d-flex align-items-center justify-content-between p-2 bg-light rounded-3"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center bg-secondary bg-opacity-10 text-secondary fw-bold"
                            style={{
                              width: "32px",
                              height: "32px",
                              fontSize: "12px",
                            }}
                          >
                            {getInitials(emp.UserName)}
                          </div>
                          <span
                            className="fw-bold text-dark"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {emp.UserName}
                          </span>
                        </div>
                        <div className="badge bg-success bg-opacity-10 text-success rounded-pill px-3 py-1 d-flex align-items-center gap-1">
                          <BsCircleFill size={6} /> Active
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className="p-3 border-top bg-light-subtle"
                  style={{ flexShrink: 0 }}
                >
                  <div className="text-danger small fw-bold mb-2">
                    ON LEAVE ({MOCK_LEAVE_DATA.length})
                  </div>
                  <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                    <div className="d-flex flex-column gap-2">
                      {MOCK_LEAVE_DATA.map((emp) => (
                        <div
                          key={emp.id}
                          className="d-flex align-items-center justify-content-between p-2 bg-white border rounded-3"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center bg-danger bg-opacity-10 text-danger fw-bold"
                              style={{
                                width: "32px",
                                height: "32px",
                                fontSize: "12px",
                              }}
                            >
                              {getInitials(emp.name)}
                            </div>
                            <span
                              className="fw-bold text-dark"
                              style={{ fontSize: "0.9rem" }}
                            >
                              {emp.name}
                            </span>
                          </div>
                          <div className="badge bg-danger bg-opacity-10 text-danger rounded-pill px-3 py-1 d-flex align-items-center gap-1">
                            <BsCircleFill size={6} /> Leave
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

          {/* COMPANY STATUS OVERVIEW */}
          <div className="content-card mt-4">
            <div className="card-header-custom">
              <h5 className="d-flex align-items-center gap-2 w-100">
                <BsBuilding className="opacity-30 com-text" />
                <span className="com-text">
                  {overviewBy === "project" ? "Project" : "Company"} Status Overview
                </span>

                <span className="dsp__views ms-auto">
                  {[
                    { key: "company", label: "Client wise" },
                    { key: "project", label: "Project wise" },
                  ].map((v) => (
                    <button
                      key={v.key}
                      type="button"
                      className={`dsp__view${overviewBy === v.key ? " is-active" : ""}`}
                      onClick={() => setOverviewBy(v.key)}
                    >
                      {v.label}
                    </button>
                  ))}
                </span>
              </h5>
            </div>
            <div className="cso__wrap">
              <table className="cso">
                <thead>
                  <tr>
                    <th>
                      {overviewBy === "project" ? "Project / Client" : "Company"}
                    </th>
                    <th>Prev. Completed</th>
                    <th>Today Completed</th>
                    <th>Pending Points</th>
                    <th>Not Started</th>
                    <th>In Progress</th>
                    <th>On Hold</th>
                    <th className="cso__split">0-2 Days</th>
                    <th>3-5 Days</th>
                    <th>6+ Days</th>
                  </tr>
                </thead>

                <tbody>
                  {overviewRows.map((entry, idx) => {
                    const c = entry.row;
                    const isGroup = entry.kind === "group";

                    const n = (v) => Number(v) || 0;
                    const pending =
                      n(c.NotStarted_Nos) + n(c.InProgress_Nos) + n(c.OnHold_Nos);

                    /* A count of nothing prints as a dash. Forty grey zeros
                       are forty things to read past before reaching the
                       figures that matter. */
                    const num = (value, cls) =>
                      n(value) > 0 ? (
                        <span className={cls}>{n(value)}</span>
                      ) : (
                        <span className="cso__zero">—</span>
                      );

                    return (
                      <tr
                        key={idx}
                        className={
                          isGroup
                            ? "cso__group"
                            : overviewBy === "project"
                            ? "cso__child"
                            : undefined
                        }
                      >
                        <td>
                          {isGroup ? c.ProjectName : c.CompanyName}
                          {isGroup && (
                            <span className="cso__count">
                              {c.Clients} client{c.Clients === 1 ? "" : "s"}
                            </span>
                          )}
                        </td>

                        <td>{num(c.PrevCompleted ?? c.Complete_Nos, "cso__prev")}</td>
                        <td>{num(c.TodayCompleted, "cso__today")}</td>
                        <td>{num(pending, "cso__pending")}</td>
                        <td>{num(c.NotStarted_Nos)}</td>
                        <td>{num(c.InProgress_Nos)}</td>
                        <td>{num(c.OnHold_Nos, "cso__warn")}</td>
                        <td className="cso__split">{num(c.Age_0_2, "cso__ok")}</td>
                        <td>{num(c.Age_3_5, "cso__warn")}</td>
                        <td>{num(c.Age_6_Plus, "cso__old")}</td>
                      </tr>
                    );
                  })}
                </tbody>

                {overviewRows.length > 0 && (
                  <tfoot>
                    <tr>
                      <td>
                        Total
                        <span className="cso__foot-note">
                          {companyTotals.companies} companies
                          {overviewBy === "project" &&
                            ` in ${
                              new Set(projectRows.map((r) => r.ProjectName)).size
                            } projects`}
                        </span>
                      </td>
                      <td className="cso__prev">{companyTotals.PrevCompleted}</td>
                      <td className="cso__today">{companyTotals.TodayCompleted}</td>
                      <td className="cso__pending">{companyTotals.Pending}</td>
                      <td>{companyTotals.NotStarted_Nos}</td>
                      <td>{companyTotals.InProgress_Nos}</td>
                      <td>{companyTotals.OnHold_Nos}</td>

                      {/* The ageing columns average rather than total — see
                          companyTotals. A sum of "how many are 0-2 days old"
                          across every client says nothing a reader can act
                          on; per client it is a shape. */}
                      <td className="cso__split">
                        {formatAvg(companyTotals.Age_0_2_Avg, companyTotals.Age_0_2)}
                        <span className="cso__foot-note">avg</span>
                      </td>
                      <td>
                        {formatAvg(companyTotals.Age_3_5_Avg, companyTotals.Age_3_5)}
                        <span className="cso__foot-note">avg</span>
                      </td>
                      <td>
                        {formatAvg(companyTotals.Age_6_Plus_Avg, companyTotals.Age_6_Plus)}
                        <span className="cso__foot-note">avg</span>
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>

          {/* The backlog itself, at the foot of the page: every count above
              is a summary of these rows. */}
          <PendingQueryTrack />
        </>
      )}
    </div>
  );
};

export default Dashboard;


